export const workspace = {
codeLanguagesLabel: "Lenguaje del código",
codeLanguages: {
curl: "curl",
js: "JavaScript",
python: "Python",
powerQuery: "Power Query",
powershell: "PowerShell",
},
overviewScreen: {
loading: "Cargando espacio de trabajo…",
fallbackWorkspaceName: "Espacio de trabajo",
fallbackTeamName: "Equipo",
fallbackPersonalName: "Personal",
notSet: "Sin definir",
roleUnavailable: "Rol no disponible",
personalMode: "Modo personal",
addSummaryHint: "Agregue un breve resumen en el perfil de la organización.",
currentContextLabel: "Contexto actual",
yourRoleLabel: "Tu rol",
currencyLabel: "Moneda",
languageLabel: "Idioma",
manageOrgA11y: "Administrar perfil de organización",
viewOrgA11y: "Ver perfil de la organización",
manageOrgTitle: "Administrar organización",
viewOrgTitle: "Ver organización",
manageOrgSubtitle: "Perfil, datos legales y resumen de la empresa.",
teamsA11y: "Equipos e invitaciones",
teamsTitle: "Equipos e invitaciones",
teamsSubtitle: "Cambia de contexto, membresías e invitaciones.",
configurationTitle: "Configuración",
configurationSubtitle: "Todo lo que puedes configurar, agrupado por área.",
groupWorkspaceLabel: "Espacio de trabajo",
groupOperationsLabel: "Operaciones",
groupTemplatesLabel: "Listas de control",
groupIntegrationsLabel: "Integraciones",
groupAiLabel: "IA",
groupBillingLabel: "Facturación",
groupSupportLabel: "Soporte",
itemOrgProfileTitle: "Perfil de la organización",
itemOrgProfileSubtitleAdmin: "Nombre legal, industria, dirección y notas privadas.",
itemOrgProfileSubtitleMember: "Ver el nombre legal, la industria y la dirección.",
itemTeamsTitle: "Equipos e invitaciones",
itemTeamsSubtitleAdmin: "Miembros, roles, cambio de contexto e invitaciones.",
itemTeamsSubtitleMember: "Ver miembros y roles; cambiar de contexto.",
itemBrandingTitle: "Marca de los informes",
itemBrandingSubtitleAdmin: "Logotipo y datos de la empresa solo para PDF, enlaces compartidos y exportaciones.",
itemBrandingSubtitleMember: "Vea el logotipo y los datos de la empresa que se usan en PDF, enlaces compartidos y exportaciones.",
itemContractorWorkTitle: "Mi trabajo como contratista",
itemContractorWorkSubtitle: "Órdenes de trabajo y solicitudes de presupuesto que le han enviado otros espacios de trabajo.",
itemMaintenancePlansTitle: "Planes de mantenimiento",
itemMaintenancePlansSubtitle: "Todos los planes recurrentes del espacio de trabajo, agrupados por activo.",
itemFeaturesTitle: "Funciones",
itemFeaturesSubtitle: "Qué está activado, bloqueado por el plan o desactivado.",
itemDefaultsTitle: "Valores regionales predeterminados",
itemDefaultsSubtitle: "Moneda, idioma, zona horaria y métodos para compartir.",
itemTemplatesTitle: "Listas de verificación",
itemTemplatesSubtitle: "Listas de verificación de inspección reutilizables.",
itemIndustryPacksTitle: "Paquetes del sector",
itemIndustryPacksSubtitle: "Puntos de partida para inmuebles, flotas, equipos e instalaciones.",
itemIntegrationsTitle: "Integraciones y API",
itemIntegrationsSubtitle: "Importaciones, API pública, MCP, automatizaciones y activos conectados.",
itemAiAuditTitle: "Auditoría de IA y automatización",
itemAiAuditSubtitle: "Uso de IA del espacio de trabajo y actividad de automatización.",
itemBillingTitle: "Facturación y uso",
itemBillingSubtitleAdmin: "Plan, créditos de IA, activos facturables y registro de créditos.",
itemBillingSubtitleMember: "Consulta el plan y el uso de créditos; solo un administrador puede modificarlos.",
itemHandbookTitle: "Manual de integración",
itemHandbookSubtitle: "Guías para conectar y automatizar AssetWRX.",
},
organizationScreen: {
  allSaved: "Guardado. Los datos de tu espacio de trabajo están al día.",
  allChangesSaved: "Todos los cambios guardados",
  saveChanges: "Guardar cambios",
  unsavedKeep: "Seguir editando",
  unsavedDiscard: "Salir",
  unsavedBody: "Has cambiado datos en esta página. Si sales ahora, esos cambios se perderán.",
  unsavedTitle: "¿Salir sin guardar?",
pageTitle: "Perfil de la organización",
pageSubtitle: "Identidad del espacio de trabajo, datos de contacto e información legal. El estilo de encabezado específico del informe se encuentra en Informes.",
memberNotice: "Solo los propietarios del espacio de trabajo pueden editar los datos de la organización y la marca de los informes. Puede ver la información compartida a continuación.",
loadingProfile: "Cargando el perfil de la organización…",
fallbackWorkspaceName: "Espacio de trabajo",
logoSectionTitle: "Logotipo del espacio de trabajo",
changeLogoA11y: "Cambiar logotipo del espacio de trabajo",
uploading: "Cargando…",
changeLogo: "Cambiar logotipo",
removeLogoA11y: "Eliminar logotipo",
remove: "Quitar",
workspaceNameLabel: "Nombre del espacio de trabajo",
workspaceNamePlaceholder: "Etiqueta del espacio de trabajo",
saveWorkspaceName: "Guardar nombre del espacio de trabajo",
organizationSectionTitle: "Organización",
summaryLabel: "Resumen",
summaryPlaceholder: "Breve descripción de tu organización",
industryLabel: "Industria",
companySizeLabel: "Tamaño de la empresa",
companySizePlaceholder: "por ej. 1–10, 11–50",
websiteLabel: "Sitio web",
websitePlaceholder: "https://example.com",
countryCodeLabel: "Código de país",
countryCodePlaceholder: "p. ej., GB",
regionLabel: "Región",
saveOrganization: "Guardar organización",
supportContactsTitle: "Contactos de soporte",
supportEmailLabel: "Correo electrónico de soporte",
supportPhoneLabel: "Teléfono de soporte",
saveSupportContacts: "Guardar contactos de soporte",
legalBillingTitle: "Legal y facturación",
legalBillingSubtitle: "Visible solo para los propietarios del espacio de trabajo.",
legalEntityNameLabel: "Nombre de la entidad legal",
tradingNameLabel: "Nombre comercial/para mostrar",
primaryContactEmailLabel: "Correo electrónico de contacto principal",
primaryContactPhoneLabel: "Teléfono de contacto principal",
registeredAddressLabel: "Dirección registrada",
operationalAddressLabel: "Dirección operativa",
taxNumberLabel: "Número fiscal / de IVA",
registrationNumberLabel: "Número de registro de la empresa",
billingContactNameLabel: "Nombre del contacto de facturación",
billingContactEmailLabel: "Correo electrónico de contacto de facturación",
billingContactPhoneLabel: "Teléfono de contacto de facturación",
saveLegalBilling: "Guardar datos legales y de facturación",
memberPrivateNote: "Los detalles de facturación, registro, impuestos y entidad jurídica están restringidos a los propietarios del espacio de trabajo.",
reportBrandingLink: "Marca de los informes y exportaciones",
savedTitle: "Guardado",
workspaceNameSaved: "Nombre del espacio de trabajo actualizado.",
saveFailedTitle: "Error al guardar",
couldNotSave: "No se pudo guardar.",
checkPhoneTitle: "Revise el número de teléfono",
checkPhoneBody: "Introduzca un número válido para el país seleccionado o deje el teléfono vacío.",
organizationDetailsSaved: "Detalles de la organización actualizados.",
legalBillingSaved: "Detalles legales y de facturación actualizados.",
permissionRequiredTitle: "Permiso necesario",
permissionRequiredBody: "Permite el acceso a la galería de fotos para subir un logotipo.",
fileTooLargeTitle: "Archivo demasiado grande",
fileTooLargeBody: "El logotipo debe pesar 10 MB o menos.",
logoUpdated: "Logotipo del espacio de trabajo actualizado.",
uploadFailedTitle: "Error al cargar",
couldNotUploadLogo: "No se pudo cargar el logotipo.",
removedTitle: "Eliminado",
logoRemoved: "Logotipo del espacio de trabajo eliminado.",
removeFailedTitle: "Error al eliminar",
couldNotRemoveLogo: "No se pudo eliminar el logotipo.",
},
brandingScreen: {
readOnlyTitle: "Sólo lectura",
readOnlyBody: "Solo los propietarios del espacio de trabajo pueden cambiar la marca del informe.",
permissionRequiredTitle: "Permiso necesario",
permissionRequiredBody: "Permite el acceso a la galería de fotos para subir un logotipo.",
fallbackWorkspaceName: "Espacio de trabajo",
workspaceBrandingAppliedTitle: "Marca del espacio de trabajo aplicada",
workspaceBrandingAppliedBody: "El nombre y el logotipo del espacio de trabajo se copiaron en los campos de marca del informe. Revise y guarde para aplicar.",
noWorkspaceTitle: "Sin espacio de trabajo",
noWorkspaceBody: "Su perfil aún no tiene una cuenta de espacio de trabajo.",
savedTitle: "Guardado",
brandingSaved: "Configuración de marca de los informes actualizada.",
saveFailedTitle: "Error al guardar",
couldNotSaveBranding: "No se pudo guardar la configuración de marca del informe.",
intro: "Se aplica a informes alojados, exportaciones PDF, resultados de inspección compartidos y correos electrónicos compartidos. Configure los campos aquí para reemplazar la marca AssetWRX predeterminada en esas salidas; déjelos en blanco para mantener los valores predeterminados de AssetWRX.",
memberHint: "Solo los propietarios del espacio de trabajo pueden editar la marca. Puede revisar la configuración actual a continuación.",
fromReportHint: "Esta sección se abrió desde el espacio de trabajo de informes. Los cambios se aplican inmediatamente a los informes alojados y a las nuevas exportaciones.",
loadingSettings: "Cargando la configuración de marca…",
reportLogoLabel: "Logotipo del informe",
reportLogoHint: "Se utiliza en informes, exportaciones PDF y correos electrónicos compartidos únicamente.",
changeLogoA11y: "Cambiar imagen del logotipo del informe",
addLogoA11y: "Agregar imagen del logotipo del informe",
changeLogo: "Cambiar logotipo de informe",
addLogo: "Agregar logotipo de informe",
removeLogoA11y: "Eliminar logotipo de informe",
removeLogo: "Eliminar logotipo de informe",
copyFromWorkspaceA11y: "Utilice el logotipo y el nombre de su espacio de trabajo para los informes",
copyFromWorkspace: "Usar el logotipo y el nombre de mi espacio de trabajo",
noLogoHint: "No se ha establecido ningún logotipo de informe: las exportaciones utilizan la marca AssetWRX hasta que agregue uno aquí.",
companyNameLabel: "Empresa/nombre para mostrar",
companyNamePlaceholder: "por ej. Servicios inmobiliarios de Northfield",
companyNameA11y: "Nombre de empresa o de visualización para los informes",
addressBlockLabel: "Bloque de dirección",
addressBlockPlaceholder: "Líneas de dirección mostradas en el encabezado del informe",
addressBlockA11y: "Bloque de dirección del informe",
contactBlockLabel: "Bloque de contacto",
contactBlockPlaceholder: "Correo electrónico / teléfono / sitio web",
contactBlockA11y: "Bloque de contacto del informe",
footerLabel: "Pie de página/descargo de responsabilidad",
footerPlaceholder: "Descargo de responsabilidad opcional para el pie de página del informe",
footerA11y: "Pie de página del informe o descargo de responsabilidad",
accentColorLabel: "Color de acento (opcional)",
accentColorA11y: "Valor hexadecimal del color de acento del informe",
accentColorHint: "Utilice formato hexadecimal (#RRGGBB). Déjelo en blanco para utilizar el acento AssetWRX predeterminado.",
savingA11y: "Guardando la marca de los informes",
saveA11y: "Guardar configuración de marca del informe",
saving: "Guardando…",
saveBranding: "Guardar marca",
},
teamsScreen: {
recentlyJoined: "Se unió recientemente",
switchFailedTitle: "No se pudo cambiar el espacio de trabajo",
tryAgain: "Inténtelo de nuevo.",
pendingInviteTitle: "Invitación de equipo pendiente",
pendingInviteBody_one: "{{count}} invitación pendiente en la gestión de equipos.",
pendingInviteBody_other: "{{count}} invitaciones pendientes en la gestión de equipos.",
teamManagementTitle: "Gestión de equipos",
teamManagementSubtitle: "Invitaciones, roles y opciones avanzadas.",
createFirstTeam: "Crea tu primer equipo",
openTeamManagement: "Abrir gestión de equipos",
teamManagementMenuSubtitle: "Configuración de pantalla completa para sus equipos e invitaciones.",
teamsAndContextTitle: "Tus equipos",
teamsAndContextSubtitle: "El equipo en el que trabajas y todos los equipos a los que perteneces.",
changeContext: "Cambiar de equipo",
workspaceLabel: "Espacio de trabajo",
currentContextLabel: "Trabajas en",
roleInContextLabel: "Tu rol",
loadFailed: "No pudimos cargar tus equipos. Vuelve a abrir esta página para intentarlo de nuevo.",
teamMembershipsTitle: "Equipos a los que perteneces",
manageInTeamSettings: "Administrar en la configuración del equipo",
noMemberships: "Actualmente no eres miembro de ningún equipo.",
membershipMeta: "Rol: {{role}} · Se unió el {{date}}",
currentBadge: "actual",
workingContextTitle: "Cambiar de equipo",
workingContextSubtitle: "Elige de qué equipo ves los activos y el trabajo. Personal muestra solo los tuyos.",
personalOption: "Personal",
pendingInviteBody_many: "{{count}} invitaciones pendientes en la gestión de equipos.",
},
aiUsageInsights: {
title: "Análisis del uso de IA",
subtitle: "Resume las llamadas, los créditos y los comentarios de los últimos {{days}} días. Se actualiza al pulsar Actualizar.",
refresh: "Actualizar",
loadingUsage: "Cargando el uso…",
alertHeader_one: "{{count}} capacidad necesita revisión",
alertHeader_other: "{{count}} capacidades necesitan revisión",
healthAttention: "Algunas funciones de IA necesitan atención: un administrador del espacio de trabajo puede revisar los detalles.",
healthNormal: "Todas las funciones de IA se ejecutan normalmente.",
kpiCreditsBurned: "Créditos consumidos",
kpiCalls: "Llamadas",
kpiErrors: "Errores",
kpiCacheHitRate: "Tasa de aciertos de caché",
projectedMonthly: "Proyectado mensualmente",
pctOfBudget: "{{pct}}% del presupuesto de {{budget}}",
extrapolatedFromWindow: "Extrapolado linealmente a partir de este periodo de {{days}} días",
noActivity: "No hay actividad de IA en este periodo. Anima a los usuarios a probar el copiloto para ver señal aquí.",
colCapability: "Capacidad",
colCalls: "Llamadas",
colCredits: "Créditos",
colAvgMs: "Media ms",
colFeedback: "👍 / 👎",
colAccept: "Aceptar",
openDetailHint: "Abrir detalle de la capacidad",
alert: {
neverHelpful_one: "{{count}} voto negativo y ninguno positivo. Señal clara de que algo falla.",
neverHelpful_many: "{{count}} votos negativos y ninguno positivo. Señal clara de que algo falla.",
neverHelpful_other: "{{count}} votos negativos y ninguno positivo. Señal clara de que algo falla.",
lowAcceptance: "La aceptación es del {{pct}} % (n={{total}}). Revisa el prompt o los ejemplos.",
highErrorRate: "El {{pct}} % de las llamadas fallan ({{errors}}/{{calls}}). Comprueba la función edge o la disponibilidad del modelo.",
},
feature: {
unknown: "Sin atribuir",
ai_assistant: "Asistente de IA",
connected_event: "Evento de un dispositivo conectado",
automation: {
asset_health_calculated: "Salud del activo calculada",
asset_compliance_calculated: "Cumplimiento del activo calculado",
asset_risk_calculated: "Riesgo del activo calculado",
asset_risk_assessment_persist_batch: "Riesgo de activos guardado en bloque",
recipe_run: "Receta de automatización ejecutada",
},
asset: {
extract_vin_or_serial: "Leer el VIN o el número de serie",
generate_advanced_report: "Informe avanzado del activo",
improve_description: "Mejorar la descripción del activo",
infer_identity: "Identificar el activo",
journey_summary: "Resumen del recorrido del activo",
timeline_summary: "Resumen de la cronología del activo",
},
assistant: {
recommend_next_actions: "Próximas acciones del asistente",
},
connected: {
event_ingest: "Mensaje de un dispositivo conectado",
},
document: {
extract_metadata: "Leer los detalles del documento",
},
esg: {
  writeup: "Resumen ESG",
},
home: {
operations_briefing: "Resumen de operaciones",
},
insights: {
recommend_next_actions: "Próximas acciones recomendadas",
},
inspection: {
analyse_image: "Analizar foto de inspección",
completed: "Inspección completada",
fix_recommendation: "Recomendación de reparación",
generate_job_drafts: "Borradores de órdenes de trabajo a partir de una inspección",
generate_summary: "Resumen de la inspección",
improve_note: "Mejorar nota de inspección",
},
job: {
completion_closeout: "Cierre de la orden de trabajo",
extract_invoice_line_items: "Leer las líneas de la factura",
generate_invoice_draft: "Borrador de factura",
improve_update_note: "Mejorar la actualización de la orden de trabajo",
suggest_certificate_draft: "Sugerir certificado",
suggest_completion_criteria: "Sugerir criterios de finalización",
suggest_follow_up_job: "Sugerir orden de trabajo de seguimiento",
},
quote: {
compare_quotes: "Comparar presupuestos",
generate_rfq_scope: "Redactar el alcance de la solicitud de presupuesto",
recommend_quote: "Recomendar un presupuesto",
summarize_quotes: "Resumir presupuestos",
},
request: {
polish_follow_up_draft: "Pulir la respuesta a la solicitud",
},
site: {
generate_advanced_report: "Informe avanzado del sitio",
},
template: {
generate_draft: "Borrador de lista de control de lista de verificación",
},
vision: {
analyse_group: "Escaneo de WRX Vision",
verify_completion: "Comprobación de pruebas de WRX Verified",
},
work: {
analyse_evidence: "Analizar pruebas del trabajo",
},
},
entityType: {
asset: "Activo",
job: "Orden de trabajo",
inspection: "Inspección",
request: "Solicitud",
quote: "Presupuesto",
site: "Sitio",
document: "Documento",
template: "Lista de control",
contact: "Contacto",
},
feedback: {
helpful: "Útil",
not_helpful: "No útil",
},
action: {
refine: "Se pidió afinar",
},
creditMode: {
none: "ninguno",
estimated: "estimado",
actual: "real",
},
alertHeader_many: "{{count}} capacidades necesitan revisión",
},
aiCapabilityDetail: {
kicker: "Detalle de capacidad · 30d",
closeA11y: "Cerrar detalle",
loading: "Cargando detalle…",
noFeedback: "Aún no hay comentarios sobre esta capacidad.",
sectionFeedback: "Desglose de comentarios",
sectionActionTaken: "Acción tomada",
sectionDailyActivity: "Actividad diaria",
noActivity: "No hay actividad en este periodo.",
sectionRecentEntities: "Entidades recientes",
totalLine_one: "{{count}} evento en total en el periodo.",
totalLine_other: "{{count}} eventos en total en el periodo.",
totalLine_many: "{{count}} eventos en total en el periodo.",
},
syncCenter: {
  errors: {
    unsupportedWrite: "Este cambio necesita una versión más reciente de la aplicación para enviarse. Sigue guardado en este dispositivo.",
    waitingOnFailedParent: "Esperando al registro al que pertenece, que no se pudo enviar. Primero corrige o descarta ese elemento en esta página.",
    transientUnknown: "Este cambio aún no se ha enviado. Se volverá a intentar; contacta con soporte si sigue ocurriendo.",
    permanentUnknown: "Este cambio no se puede aplicar automáticamente. Revísalo o descártalo.",
    serverError: "El servidor tuvo un problema. Se volverá a enviar; contacta con soporte si sigue ocurriendo.",
    rateLimited: "El servidor está ocupado. Se volverá a enviar en breve.",
    network: "Problema de conexión. Se enviará automáticamente, o puedes volver a intentarlo ahora.",
    conflict: "Ya hay una versión más reciente guardada. Descarta este cambio y revisa la última versión.",
    notFound: "Lo que este cambio modificaba se ha eliminado. Puedes descartarlo.",
    permission: "No tienes permiso para enviar este cambio. Pídeselo a un administrador del espacio de trabajo.",
    blocked: "Este cambio está guardado en este dispositivo, pero no se pudo enviar. Vuelve a intentarlo o descártalo.",
    authRetry: "Vuelve a iniciar sesión para enviar este cambio. Está guardado en este dispositivo.",
  },
pageTitle: "Cambios sin enviar",
pageSubtitle: "Cambios guardados en este dispositivo que esperan a enviarse.",
healthTitle: "Salud",
statusSectionTitle: "Estado",
retryAll: "Enviar ahora",
queuedWritesSynced: "Todo está enviado",
lastSync: "Último envío {{age}}",
noSyncsYet: "Aún no se ha enviado nada",
queuedLabel: "Pendiente de enviar",
inFlightLabel: "Enviando ahora",
lastFlushLabel: "Último envío",
lastDurationLabel: "Última duración",
never: "Nunca",
pendingWritesTitle: "Pendiente de enviar",
unsentAnswersTitle: "Respuestas de inspección en este dispositivo",
unsentAnswersBody: "Se envían automáticamente cuando estás en línea. Si la inspección se modificó en otro lugar, ábrela para revisarlas y enviarlas.",
openInspection: "Abrir inspección",
queuedInspectionPhotos: "Fotos de inspección pendientes de subir: {{total}}",
recoveryNote_one: "Un cambio guardado por una versión anterior de la aplicación no tiene propietario registrado. Se conservó en lugar de asignarlo a quien iniciara sesión después. Si este trabajo es suyo, reclámelo y se sincronizará; si no, descártelo.",
recoveryNote_other: "{{count}} cambios guardados por una versión anterior de la aplicación no tienen propietario registrado. Se conservaron en lugar de asignarse a quien iniciara sesión después. Si este trabajo es suyo, reclámelo y se sincronizará; si no, descártelo.",
claimAsMine: "Reclamar como mío",
discard: "Descartar",
claimAllAsMine: "Reclama todo como mío",
discardAll: "Descartar todo",
noQueuedWritesTitle: "Nada pendiente de enviar",
noQueuedWritesBody: "Los cambios que haces en este dispositivo se envían en cuanto tienes conexión. Las fotos de inspección aparecen en su inspección.",
hideTechnicalDetails: "Ocultar detalles técnicos",
showTechnicalDetails: "Mostrar detalles técnicos",
technicalDetail_one: "{{rawError}} · {{count}} intento",
technicalDetail_other: "{{rawError}} · {{count}} intentos",
retry: "Reintentar",
offlineSupportTitle: "Qué funciona sin conexión",
statusOnlineRequired: "Necesita conexión",
statusLocalDraft: "Se guarda primero en este dispositivo",
policyEntity: {
Asset: "Activo",
Inspection: "Inspección",
Job: "Orden de trabajo",
Schedule: "Programación",
Request: "Solicitud",
Comment: "Comentario",
Media: "Multimedia",
},
policyAction: {
createAsset: "Crear activo",
editAsset: "Editar activo",
addDocument: "Añadir documento",
answerChecklistItems: "Responder elementos de la lista de verificación",
startInspection: "Iniciar una nueva inspección",
submitInspection: "Pausar, continuar o completar una inspección",
createJob: "Crear orden de trabajo",
addJobPhotos: "Añadir fotos al crear una orden de trabajo",
postActivity: "Publicar notas de actividad y fotos",
moveJobStatus: "Aceptar, programar o dar conformidad a una orden",
startPauseCompleteJob: "Empezar, pausar o completar una orden de trabajo",
updateJobDetails: "Actualizar los detalles de la orden de trabajo",
scheduleInspection: "Programar inspección",
answerCheck: "Responder una comprobación",
recordMeterReading: "Registrar una lectura de contador",
reportCantComplete: "Informar de que no puedes completar el trabajo",
decideChangeRequest: "Decidir sobre una solicitud de cambio",
createOrRespondRequest: "Crear o responder",
postComment: "Publicar comentario",
uploadEvidence: "Subir pruebas",
},
supportCopy: {
queued: "Se guarda en el dispositivo y se sincroniza automáticamente",
local_draft: "Se guarda en el dispositivo hasta enviarlo",
online_required: "Requiere conexión",
},
conflictCopy: {
idempotent_replay: "Reintento seguro: la misma operación no se duplica.",
merge_review: "Si los datos cambiaron en el servidor, revísalos y combínalos antes de guardar.",
latest_write: "Prevalece el último cambio aceptado por el servidor.",
},
entryAsset: "Nuevo activo",
entryInspectionJob: "Trabajo de inspección",
entryJob: "Nueva orden de trabajo",
entryJobPhoto: "Foto de orden de trabajo",
entryJobUpdate: "Actualización de la orden de trabajo",
entryScheduledInspection: "Inspección programada",
entryAssetDocument: "Documento del activo",
entryFieldMove: "Inicio, pausa o finalización",
entryNewInspection: "Nueva inspección",
ageJustNow: "hace un momento",
ageMinutesAgo: "hace {{mins}} min",
ageHoursAgo: "hace {{hrs}} h",
ageDaysAgo: "hace {{days}} d",
readErrorBody: "No se pudo leer el trabajo guardado. Todavía está en este dispositivo y no ha sido descartado.",
flushErrorBody: "No pudimos enviar tus cambios. Siguen guardados en este dispositivo.",
claimErrorBody: "Esos cambios no se pudieron reclamar. Todavía están guardados en este dispositivo.",
discardManyErrorBody: "Esos cambios no se pudieron descartar. Todavía están guardados en este dispositivo.",
discardOneErrorBody: "No se pudo descartar el cambio. Sigue guardado en este dispositivo.",
recoveryNote_many: "{{count}} cambios guardados por una versión anterior de la aplicación no tienen propietario registrado. Se conservaron en lugar de asignarse a quien iniciara sesión después. Si este trabajo es suyo, reclámelo y se sincronizará; si no, descártelo.",
technicalDetail_many: "{{rawError}} · {{count}} intentos",
},
trustCenter: {
pageTitle: "Centro de confianza",
pageSubtitle: "Auditoría, integraciones, acceso y postura de cumplimiento de este espacio de trabajo.",
loading: "Cargando...",
auditLogTitle: "Registro de auditoría",
auditLogDescription: "Quién hizo qué, cuándo, en todos los activos, órdenes de trabajo, inspecciones y acciones administrativas.",
auditLogEmptyTitle: "Registro de auditoría aún no disponible",
auditLogEmptyBody: "Una vez que la fuente de auditoría esté habilitada para su espacio de trabajo, cada acción significativa aparecerá aquí con actor, objetivo y marca de tiempo.",
integrationHealthTitle: "Estado de la integración",
integrationHealthDescription: "Conectores API + MCP + IoT: estado de conexión, última sincronización, tasa de error.",
integrationHealthEmptyTitle: "No hay integraciones conectadas",
integrationHealthEmptyBody: "Conecta una integración para ver aquí su estado en vivo, incluida la última sincronización correcta, la tasa de errores y el estado de los reintentos.",
webhookRetryTitle: "Reintentos de webhook",
webhookRetryDescription: "Entregas de webhooks salientes que fallaron y se volvieron a intentar, con cuerpos y códigos de respuesta.",
webhookRetryEmptyTitle: "No hay fallas en el webhook",
webhookRetryEmptyBody: "Las entregas fallidas de webhooks (con su historial de reintentos y cuerpos) aparecerán aquí cuando ocurran.",
apiKeysTitle: "Claves de API y alcances",
apiKeysDescription: "Claves emitidas, alcances, estado de rotación y quién las creó.",
apiKeysEmptyTitle: "No se han emitido claves API",
apiKeysEmptyBody: "Cuando el propietario de un espacio de trabajo crea una clave API, sus alcances y cadencia de rotación residirán aquí.",
rolesTitle: "Roles y permisos",
rolesDescription: "Quién puede hacer qué en todos los equipos, con permisos y anulaciones efectivos.",
rolesEmptyTitle: "Aún no se han registrado asignaciones de roles",
rolesEmptyBody: "Cada usuario y equipo, los permisos que tienen y cualquier anulación aparecerán aquí.",
complianceTitle: "Postura de cumplimiento",
complianceDescription: "Preparación SOC2/ISO, residencia de datos, retención y estado de exportación.",
complianceEmptyTitle: "Aún no se han registrado señales de cumplimiento",
complianceEmptyBody: "La preparación SOC2/ISO, la residencia de datos, la retención y el estado de exportación aparecerán aquí a medida que se registran para este espacio de trabajo.",
audit: {
byActor: "por {{name}}",
toRecipient: "para {{name}}",
action: {
asset: {
created: "Activo creado",
updated: "Activo actualizado",
shared: "Activo compartido",
share_revoked: "Acceso compartido al activo revocado",
},
inspection: {
created: "Inspección creada",
started: "Inspección iniciada",
completed: "Inspección completada",
failed_item_recorded: "Elemento fallido registrado",
approved: "Inspección aprobada",
reopened: "Inspección reabierta",
shared: "Informe compartido",
share_approved: "Informe aprobado",
share_rejected: "Informe rechazado",
},
job: {
created: "Orden de trabajo creada",
assigned: "Orden de trabajo asignada",
started: "Orden de trabajo iniciada",
completed: "Orden de trabajo completada",
reopened: "Orden de trabajo reabierta",
verified: "Orden de trabajo verificada",
},
document: {
created: "Documento añadido",
renewed: "Documento renovado",
superseded: "Documento sustituido",
},
compliance: {
expiring_detected: "Vencimiento de cumplimiento detectado",
},
insight: {
generated: "Análisis generado",
feedback_submitted: "Valoración de un análisis enviada",
},
technician: {
assignment_recommended: "Responsable recomendado",
assignment_accepted: "Asignación aceptada",
},
condition: {
assessment_calculated: "Estado evaluado",
recommendation_created: "Recomendación de estado creada",
recommendation_accepted: "Recomendación de estado aceptada",
recommendation_dismissed: "Recomendación de estado descartada",
},
scheduling: {
recommendation_shown: "Sugerencia de programación mostrada",
recommendation_selected: "Sugerencia de programación elegida",
},
assistant: {
  change: "Cambiado con el asistente",
  undo: "Deshecho con el asistente",
},
},
entity: {
asset: "Activo",
job: "Orden de trabajo",
inspection: "Inspección",
document: "Documento",
asset_share: "Activo compartido",
inspection_share: "Informe compartido",
insight: "Análisis",
compliance: "Cumplimiento",
technician: "Asignación",
site: "Sede",
scheduled_inspection: "Inspección programada",
template: "Lista de control",
asset_request: "Solicitud",
},
},
},
teamInvite: {
pageTitle: "Invitación al equipo",
invalidLink: "Enlace de invitación no válido",
loadTimeout: "La invitación tarda demasiado en cargarse. Comprueba tu conexión y vuelve a intentarlo.",
notFound: "Invitación no encontrada",
expiredMessage: "Tu invitación{{where}} expiró{{when}}. Pídele a quien te invitó que envíe una nueva.",
expiredWhereSuffix: " a {{teamName}}",
expiredWhenSuffix: " el {{date}}",
loadFailed: "No se pudo cargar la invitación",
emailMismatchTitle: "El correo electrónico no coincide",
emailMismatchBody: "Esta invitación fue enviada a {{email}}. Por favor inicia sesión con ese correo electrónico para aceptar.",
errorTitle: "Error",
linkSendFailedTitle: "No se pudo enviar el enlace",
linkSendFailedBody: "Vuelva a intentarlo o pídale a quien lo invitó que vuelva a enviar la invitación.",
loadingInvitation: "Cargando invitación…",
invalidOrExpiredTitle: "No válido o caducado",
linkNoLongerValid: "Este enlace de invitación ya no es válido.",
tryAgain: "Intentar de nuevo",
goToApp: "Ir a AssetWRX",
cardTitle: "Invitación al equipo",
invitedPrefix: "Te han invitado a unirte",
invitedRoleSuffix: "como {{role}}.",
checkEmailForLink: "Revisa {{email}} para encontrar un enlace de inicio de sesión. Te trae de vuelta aquí para aceptar.",
signInAsEmail: "Inicia sesión como {{email}} para aceptar esta invitación",
linkSent: "Enlace enviado",
emailSignInLink: "Envíeme un correo electrónico con un enlace de inicio de sesión",
signIn: "Iniciar sesión",
wrongAccountHint: "Esta invitación fue enviada a {{email}}. Inicia sesión con esa cuenta.",
signInDifferentAccount: "Iniciar sesión con otra cuenta",
accept: "Aceptar",
decline: "Rechazar",
},
logoOrInitials: {
logoA11y: "Logotipo del espacio de trabajo",
initialsA11y: "Iniciales del espacio de trabajo",
},
shellTabsListA11y: "Secciones de configuración del espacio de trabajo",
teamManage: {
offerFailedTitle: "No se pudo enviar la oferta",
tryAgain: "Inténtalo de nuevo en un momento.",
offerSent: "Se ha pedido a {{name}} que acepte la propiedad. Nada cambia hasta que acepte.",
linkCopied: "Enlace de invitación copiado. Envíalo como prefieras.",
inviteLinkTitle: "Enlace de invitación",
checkEmails: "Revisa {{emails}} e inténtalo de nuevo.",
enterEmail: "Introduce al menos una dirección de correo electrónico.",
invitesSent_one: "Invitación enviada a {{email}}. Recibirá un correo con un enlace para unirse y aparecerá en Miembros cuando acepte.",
invitesSent_many: "{{count}} invitaciones enviadas. Cada persona recibe un correo con un enlace para unirse y aparece en Miembros cuando acepta.",
invitesSent_other: "{{count}} invitaciones enviadas. Cada persona recibe un correo con un enlace para unirse y aparece en Miembros cuando acepta.",
undeliveredTitle: "Invitación guardada, correo no enviado",
undeliveredBody: "No pudimos enviar el correo a {{emails}}. Toca Copiar enlace de invitación y envíaselo tú.",
copyInviteLink: "Copiar enlace de invitación",
ok: "Aceptar",
joined: "Te has unido a {{team}}. El trabajo compartido con el equipo ya aparece en Inicio y en Trabajo.",
joinFailedTitle: "No se pudo unir al equipo",
notNow: "Ahora no",
declineTitle: "¿Rechazar la invitación?",
declineBody: "¿Rechazar la invitación a {{team}}? Necesitarás una nueva invitación para unirte más adelante.",
declineFailedTitle: "No se pudo rechazar la invitación",
created: "{{name}} está listo. Invita a personas para que vean sus activos y su trabajo.",
createFailedTitle: "No se pudo crear el equipo",
createFailedBody: "No pudimos crear el equipo ahora mismo. Inténtalo de nuevo en un momento.",
switchedTo: "Ahora trabajas en {{team}}",
switchFailedTitle: "No se pudo cambiar de equipo",
switchToA11y: "Cambiar a {{team}}",
personalHint: "Estás en Personal y solo ves tu propio trabajo. Toca un equipo para cambiar a él.",
tapToSwitchHint: "Toca un equipo para cambiar a él. Los activos y el trabajo pasan a ser los de ese equipo.",
noTeamTitle: "Aún no tienes equipo",
noTeamBody: "Crea un equipo para compartir activos y trabajo con tus compañeros. Después podrás invitar a personas.",
adoptAssets_one: "Añade tu activo a {{team}}. Ahora mismo solo tú puedes verlo.",
adoptAssets_many: "Añade tus {{count}} activos a {{team}}. Ahora mismo solo tú puedes verlos.",
adoptAssets_other: "Añade tus {{count}} activos a {{team}}. Ahora mismo solo tú puedes verlos.",
adoptFailedTitle: "No se pudieron añadir los activos",
membershipHint: "Las personas que invites aquí pueden iniciar sesión y trabajar en este equipo. Para guardar los datos de alguien sin darle acceso (un contratista, un inquilino), añádelo en Contactos.",
emailPlaceholder: "alex@example.com\nsam@example.com",
inviteAsA11y: "Invitar como {{role}}",
roleDescription: {
member: "Completar y actualizar trabajos, inspecciones y solicitudes.",
admin: "Invitar y quitar personas y cambiar la configuración del equipo.",
},
sendInvite_one: "Enviar invitación",
sendInvite_many: "Enviar {{count}} invitaciones",
sendInvite_other: "Enviar {{count}} invitaciones",
inviteExpired: "Caducó el {{date}}. Toca reenviar para invitarle de nuevo.",
inviteSentOn: "Enviada el {{date}}",
resendFailedTitle: "No se pudo reenviar la invitación",
resent: "Invitación enviada de nuevo a {{email}}.",
resendA11y: "Reenviar la invitación a {{email}}",
cancelInviteA11y: "Cancelar la invitación de {{email}}",
cancelInviteFailedTitle: "No se pudo cancelar la invitación",
cancelInviteConfirmTitle: "¿Cancelar esta invitación?",
cancelInviteConfirmBody: "Si {{email}} ya tiene el enlace, dejará de funcionar.",
cancelInviteConfirm: "Cancelar invitación",
membersTitle: "Miembros · {{n}}",
mfaPending: "{{n}} pendientes de configurar",
mfaAllCovered: "Todos están protegidos",
mfaSocialExempt: "{{n}} inician sesión con Google o Apple (no es necesario)",
mfaOnA11y: "{{name}} tiene la verificación en dos pasos activada",
mfaOffA11y: "{{name}} no tiene verificación en dos pasos",
moreActionsA11y: "Más acciones para {{name}}",
yourSkills: "Tus habilidades",
memberSkills: "Habilidades de {{name}}",
skillsSaveFailedTitle: "No se pudieron guardar esas habilidades",
skillsSaveFailedBody: "No se ha cambiado nada. Comprueba tu conexión e inténtalo de nuevo.",
saveSkills: "Guardar habilidades",
transferBody: "¿Ofrecer la propiedad del equipo a {{name}}? Debe aceptar antes de que cambie nada; después pasarás a ser administrador.",
sendOffer: "Enviar oferta",
resetMfaBody: "¿Borrar la verificación en dos pasos de {{name}}? Se le pedirá que configure de nuevo una app de autenticación la próxima vez que inicie sesión. Úsalo cuando alguien haya perdido su teléfono.",
reset: "Restablecer",
resetMfaDoneTitle: "Verificación en dos pasos restablecida",
resetMfaDone: "{{name}} podrá configurar de nuevo la verificación en dos pasos la próxima vez que inicie sesión.",
resetMfaNothing: "{{name}} no tenía verificación en dos pasos. No hay nada que restablecer.",
resetFailedTitle: "No se pudo restablecer la verificación en dos pasos",
removeBody: "¿Quitar a {{name}} del equipo?",
removeBodyWithJobs_one: "¿Quitar a {{name}} del equipo? {{count}} trabajo abierto sigue asignado a esa persona hasta que lo reasignes.",
removeBodyWithJobs_many: "¿Quitar a {{name}} del equipo? {{count}} trabajos abiertos siguen asignados a esa persona hasta que los reasignes.",
removeBodyWithJobs_other: "¿Quitar a {{name}} del equipo? {{count}} trabajos abiertos siguen asignados a esa persona hasta que los reasignes.",
remove: "Quitar",
leaveBody: "¿Salir de {{team}}? Necesitarás una nueva invitación para volver.",
leave: "Salir",
leaveFailedTitle: "No se pudo salir del equipo",
deleteBody: "¿Eliminar {{team}}? Sus activos, inspecciones y trabajos vuelven a tu cuenta. No se puede deshacer.",
delete: "Eliminar",
deleteFailedTitle: "No se pudo eliminar el equipo",
renameFailedTitle: "No se pudo cambiar el nombre del equipo",
theMember: "El miembro",
noMemberMatches: "Ningún miembro coincide.",
defaults: {
companyTitle: "Valores predeterminados de la empresa",
companyHint: "Se aplican en toda tu empresa. También puedes cambiarlos en Cuenta → Configuración.",
teamTitle: "Configuración de este equipo",
teamHint: "Usa los valores de la empresa o define otros para este equipo.",
teamCurrency: "Moneda del equipo",
teamSharing: "Cómo comparte el trabajo este equipo",
sameAsCompany: "Igual que la empresa",
setForTeam: "Definir para este equipo",
inUse: "En uso para este equipo",
},
errors: {
teamNotFound: "No encontramos ese equipo. Vuelve atrás y ábrelo de nuevo.",
inviteNotFound: "No se encontró la invitación o ha caducado.",
invite: "No se pudo enviar la invitación. Inténtalo de nuevo en un momento.",
resend: "No se pudo reenviar la invitación. Inténtalo de nuevo en un momento.",
accept: "No se pudo unir al equipo. Comprueba que la invitación sigue abierta y que has iniciado sesión con el correo al que se envió.",
deleteTeam: "No se pudo eliminar el equipo. Inténtalo de nuevo en un momento.",
onlyOwnerDelete: "Solo el propietario del equipo puede eliminarlo.",
transfer: "No se pudo enviar la oferta. Inténtalo de nuevo en un momento.",
acceptTransfer: "No se pudo aceptar la propiedad. Inténtalo de nuevo en un momento.",
declineTransfer: "No se pudo rechazar la oferta. Inténtalo de nuevo en un momento.",
cancelTransfer: "No se pudo cancelar la oferta. Inténtalo de nuevo en un momento.",
promote: "No se pudo hacerle propietario. Inténtalo de nuevo en un momento.",
demote: "No se pudo cambiar su rol. Inténtalo de nuevo en un momento.",
alreadyMember: "Esta persona ya está en el equipo.",
alreadyInvited: "Ya se ha enviado una invitación a este correo.",
noAccount: "Tu espacio de trabajo aún se está configurando. Espera un momento e inténtalo de nuevo.",
},
},
featuresScreen: {
  lockedRowA11y: "{{feature}}, bloqueada por el plan. Abre los planes que la incluyen.",
  statusNotYet: "Aún no disponible",
  title: "Funciones",
  subtitle: "Lo que está activado en este espacio de trabajo. Toca una función bloqueada por el plan para ver los planes que la incluyen.",
  simplePresetTitle: "Preajuste Simple",
  simplePresetBody: "El conjunto básico para un equipo pequeño: activos, sitios, solicitudes, inspecciones, órdenes de trabajo, revisiones, informes, contactos y planes de mantenimiento. Análisis, contratistas, equipos, integraciones, IA y herramientas de desarrollo se desactivan, y cada uno está a un interruptor de distancia aquí.",
  simplePresetButton: "Usar el preajuste Simple",
  simplePresetConfirm: "¿Desactivar Análisis, Contratistas, Equipos, Integraciones, IA y Desarrollo para este espacio de trabajo? Cada uno queda a un interruptor de distancia.",
  simplePresetApplied: "Cambiado al preajuste Simple.",
  switchA11y: "{{feature}}: activar o desactivar para este espacio de trabajo",
  switchFailed: "El cambio no se guardó. Comprueba la conexión e inténtalo de nuevo.",
  adminHint: "Los propietarios y administradores cambian las funciones aquí; los demás ven lo que está activo.",
  statusEnabled: "Activada",
  statusDisabled: "Desactivada",
  statusLockedPlan: "Bloqueada por el plan",
  statusRestrictedRole: "Restringida por el rol",
  statusDisabledAdmin: "Desactivada en este espacio de trabajo",
  statusBeta: "Beta",
  statusDependency: "Necesita otra función",
  statusUnavailable: "No disponible",
  statusSetByAssetwrxOn: "Activada por AssetWRX",
  statusSetByAssetwrxOff: "Desactivada por AssetWRX",
  statusLoading: "Comprobando…",
  modules: "Módulos",
  capabilities: "Funciones",
  empty: "Todavía no hay funciones que mostrar.",
  planLabel: "Plan: {{plan}}",
  planUngated: "Plan: sin límites aplicados",
},
featureCatalog: {
modules: {
assets: { title: "Activos" },
sites: { title: "Sitios" },
requests: { title: "Solicitudes" },
inspections: { title: "Inspecciones" },
jobs: { title: "Órdenes de trabajo" },
reviews: { title: "Revisiones" },
reports: { title: "Informes" },
analytics: { title: "Analítica" },
contacts: { title: "Contactos" },
contractors: { title: "Contratistas" },
teams: { title: "Equipos" },
automation: { title: "Automatización" },
integrations: { title: "Integraciones" },
ai: { title: "IA" },
administration: { title: "Administración" },
settings: { title: "Ajustes" },
developer: { title: "Desarrolladores" },
},
capabilities: {
  asset_360: { title: "Asset 360", description: "El informe Asset 360: veredicto, cuadro de mando, secciones para el lector elegido, plan de acción y calidad de datos, con versión con IA a petición." },
  site_360: { title: "Site 360", description: "El informe Site 360: todo el sitio, sus edificios y zonas, cumplimiento, riesgo, trabajos y contratistas, con versión con IA a petición." },
  esg: { title: "ESG y sostenibilidad", description: "Energía, carbono, certificados energéticos y refrigerantes con gases fluorados para sitios y activos, con vista de cartera y un capítulo ESG en Site 360 y Asset 360. Un complemento de pago." },
  esg_ai_writeup: { title: "Resumen ESG con IA", description: "Un resumen ESG escrito con acciones sugeridas, creado por la IA a partir de las cifras ESG. Usa créditos." },
group_rules: { title: "Reglas de grupo", description: "Reglas que programan la misma lista de verificación en cada activo que coincide y la mantienen en los activos añadidos después." },
rounds: { title: "Rondas", description: "Un trabajo que recorre una lista de verificación por varios activos en orden." },
contractor_inspections: { title: "Inspecciones por contratistas", description: "Asigne una inspección a un contratista con cuenta de AssetWRX; aparece en su trabajo y la realiza con la misma lista de verificación." },
sub_jobs: { title: "Subórdenes", description: "Una orden de trabajo puede tener subórdenes, cada una con su persona o contratista, fecha, comprobaciones y costes; la orden principal las espera." },
custom_asset_types: { title: "Tipos de activo y campos personalizados", description: "Tus propios tipos de activo con sus propios campos, además de Lugar, Equipo, Vehículo y Otro." },
bulk_asset_setup: { title: "Creación masiva y plantillas de instalación", description: "Crea muchos lugares o activos a la vez, o un edificio entero a partir de una plantilla de instalación." },
contact_import: { title: "Importación de contactos", description: "Importa contactos desde la agenda del teléfono o desde un archivo." },
ai_checklist_generation: { title: "Generación de listas con IA", description: "Redacta una lista de verificación con IA a partir de una descripción, una foto o un documento." },
assistant_changes: { title: "El asistente puede cambiar registros", description: "El asistente prepara activos, sedes, inspecciones, trabajos y reglas de grupo nuevos o actualizados para que una persona los confirme." },
assistant_planning: { title: "Planificación y optimización del asistente", description: "El asistente planifica días, equilibra la carga de trabajo, sugiere horarios y asesora sobre programas de mantenimiento." },
assistant_insights: { title: "Análisis y resúmenes del asistente", description: "El asistente explica tendencias, costes y causas, prepara informes y ofrece un resumen semanal." },
assistant_photo: { title: "Preguntas al asistente sobre fotos", description: "Pregunta al asistente sobre una foto que hagas o elijas." },
assistant_voice: { title: "Voz del asistente", description: "Habla con el asistente y escucha sus respuestas (requiere la última versión de la app de la tienda)." },
feature_requests: { title: "Solicitudes de funciones", description: "Solicita una función, sigue tus solicitudes y vota las ideas que estamos considerando." },
qr_codes: { title: "Códigos QR", description: "Genera y escanea códigos QR para identificar activos." },
barcode_scan: { title: "Escaneo de códigos de barras", description: "Escanea códigos de barras para buscar o registrar identificadores de activos." },
condition_intelligence: { title: "Inteligencia de estado", description: "Estado del activo basado en reglas, recomendaciones de riesgo y adecuación de técnicos en el activo y en el planificador." },
location_tracking: { title: "Seguimiento de ubicación", description: "Historial de ubicaciones del activo y las ubicaciones registradas por inspecciones, órdenes de trabajo y fuentes conectadas." },
knowledge_base: { title: "Base de conocimiento", description: "Guías prácticas, preguntas frecuentes, notas y archivos de un activo, la búsqueda de conocimiento entre activos y enlaces para compartir sin iniciar sesión." },
approvals: { title: "Aprobaciones", description: "Flujos de aprobación y triaje para solicitudes y finalizaciones." },
photo_capture: { title: "Captura de fotos", description: "Captura fotos como prueba en inspecciones, órdenes de trabajo y solicitudes." },
video_capture: { title: "Captura de vídeo", description: "Adjunta vídeos cortos como prueba." },
drawing: { title: "Dibujo / anotaciones", description: "Anota las fotos con dibujos y llamadas." },
voice_dictation: { title: "Dictado por voz", description: "Dicta notas y contenido de campo con la voz." },
speech_recognition: { title: "Reconocimiento de voz", description: "Conversión de voz a texto en el dispositivo para el dictado por voz." },
ml_kit: { description: "Funciones de aprendizaje automático en el dispositivo (etiquetas, códigos de barras, texto)." },
evidence_intelligence: { title: "Inteligencia de pruebas", description: "Analiza las pruebas del trabajo en el dispositivo y recurre a la IA solo cuando se solicita." },
wrx_vision: { description: "Escanea un grupo o elemento de inspección; lectura en el dispositivo de contadores, identificadores y códigos de barras, con sugerencias que se revisan antes de guardar nada." },
wrx_vision_cloud: { title: "Análisis en la nube de WRX Vision", description: "Análisis en la nube de un escaneo de Vision: estado, defectos y comprobaciones no observadas según los criterios de la lista de control." },
wrx_vision_pack_fleet: { title: "Paquete de flotas de WRX Vision", description: "Comprobaciones de daños en vehículos: abolladuras, arañazos, cristales, luces, neumáticos y ruedas." },
wrx_vision_pack_equipment: { title: "Paquete de equipos de WRX Vision", description: "Comprobaciones de maquinaria y equipos: protecciones, fugas, mangueras, cables, corrosión, placas y contadores." },
wrx_vision_pack_property: { title: "Paquete de inmuebles de WRX Vision", description: "Comprobaciones de estancias y edificios: humedad, crecimiento similar al moho, grietas, cristales, instalaciones y acceso." },
wrx_vision_pack_safety: { title: "Paquete de equipos de seguridad de WRX Vision", description: "Comprobaciones visuales de equipos de seguridad: extintores, alarmas, señalización y acceso. Nunca certifica." },
wrx_vision_training_share: { title: "Datos de mejora de WRX Vision", description: "Activado de forma predeterminada: las fotos de prueba de las sugerencias de Vision revisadas se usan para mejorar Vision. El propietario del espacio de trabajo puede desactivarlo." },
wrx_verified: { description: "Pruebas de finalización en las órdenes de trabajo: resultados esperados, fotos de antes y después, y una comprobación de pruebas que decide el revisor." },
work_intelligence: { title: "Inteligencia del trabajo", description: "Análisis compartido de las pruebas del trabajo en todos los flujos." },
work_planning: { description: "Planifica quién hace qué, cuándo y en qué orden: calendario de personas por tiempo, capacidad, desplazamientos, disponibilidad de piezas y habilidades, y planes sugeridos que aplica una persona." },
schedule_exceptions: { title: "Gobierno de la programación", description: "Solicitudes desde campo para omitir, reprogramar o reasignar trabajo programado, y las decisiones sobre ellas." },
compliance_register: { title: "Registro de cumplimiento", description: "Registro de todo el espacio de trabajo con certificados, renovaciones y pruebas vencidas." },
journey_intelligence: { title: "Inteligencia de recorridos", description: "Narración y análisis con IA sobre los recorridos operativos." },
journey_analytics: { title: "Analítica de recorridos", description: "Paneles y embudos del flujo de recorridos en toda la cartera." },
power_bi_export: { title: "Exportación a Power BI", description: "Exporta conjuntos de datos analíticos para Power BI." },
quotes: { title: "Presupuestos", description: "Solicita, compara y selecciona presupuestos de contratistas." },
scheduling: { title: "Programación", description: "Planificación en calendario y trabajo programado." },
recurring_work: { title: "Trabajo recurrente", description: "Inspecciones recurrentes y planes de mantenimiento preventivo." },
maintenance_programmes: { title: "Programas de mantenimiento", description: "Programas de mantenimiento en varias etapas por contador, calendario y etapas secuenciadas." },
csv_import: { title: "Importación CSV", description: "Importa contactos y activos desde CSV." },
excel_import: { title: "Importación desde Excel", description: "Importa datos estructurados desde libros de Excel." },
power_automate: { description: "Activa flujos de Power Automate a partir de eventos de la plataforma." },
iot_connectors: { title: "Conectores IoT", description: "Recibe señales IoT para generar trabajo." },
embed: { title: "AssetWRX integrado", description: "Ejecuta vistas seleccionadas de AssetWRX (Trabajo, Activos, inspecciones, órdenes de trabajo, informes) dentro de otro portal, sin la interfaz de la app AssetWRX." },
embed_interactive: { title: "Integraciones interactivas", description: "Permite que las vistas integradas de AssetWRX actualicen activos, realicen inspecciones y cambien órdenes de trabajo, no solo que las muestren." },
ai_summary: { title: "Resúmenes con IA", description: "Resúmenes y borradores generados por IA en todas las pantallas." },
ai_assistants: { title: "Asistentes de IA", description: "Asistentes y copilotos de IA interactivos." },
field_ai_assist: { title: "Ayuda de IA en los campos", description: "Dicta, mejora y resume en un campo de texto, justo donde trabajas." },
industry_packs: { title: "Paquetes sectoriales", description: "Instala paquetes seleccionados de listas de control y planes de mantenimiento, con sugerencias de paquetes por activo." },
offline_mode: { title: "Modo sin conexión", description: "Trabaja sin conexión con sincronización automática al reconectar." },
notifications: { title: "Notificaciones", description: "Notificaciones en la app, push y por correo electrónico." },
rest_api: { description: "Acceso a la API REST propia." },
graphql: { description: "Acceso a la API GraphQL." },
webhooks: { title: "Webhooks salientes", description: "Suscríbete a webhooks salientes firmados." },
mcp: { description: "Acceso mediante Model Context Protocol para integraciones con agentes." },
},
},
shellTabs: {
industryPacks: "Paquetes por sector",
assetTypes: "Tipos de activo",
features: "Funciones",
overview: "Resumen",
organization: "Organización",
defaults: "Valores predeterminados",
teams: "Equipos",
reports: "Marca de los informes",
integration: "Integraciones",
},
integrationHub: {
  ownerOnly: "Solo el propietario del espacio de trabajo, {{owner}}, puede configurar integraciones, claves de API y acceso de IA. Puedes ver lo que está conectado; pide a {{owner}} que configure lo nuevo.",
  ownerOnlyUnnamed: "Solo el propietario del espacio de trabajo puede configurar integraciones, claves de API y acceso de IA. Puedes ver lo que está conectado; pide al propietario que configure lo nuevo.",
askOwnerSetup: "Pide a {{owner}} que lo configure.",
askOwnerSetupUnnamed: "Pide al propietario del espacio de trabajo que lo configure.",
tryAgainShortly: "Inténtalo de nuevo en un momento.",
loadOfflineHint: "Comprueba que este dispositivo tiene conexión y vuelve a intentarlo.",
conditionInvalidTitle: "Revisa esta condición",
conditionInvalidBody: "Para una lista, escribe los valores entre corchetes, por ejemplo [\"Abierto\", \"Vencido\"].",
recipeDraftCreated: "Borrador de receta guardado. Actívalo cuando estés listo.",
retryQueued: "Reintento iniciado. El resultado aparece en el historial de ejecuciones.",
importRowFailed: "No se pudo guardar la fila {{row}}. Revisa sus valores.",
importCustomTypeUnknown: "Fila {{row}}: no hay ningún tipo de activo llamado «{{name}}» para esta clase, así que se guardó sin tipo.",
importSitsInMissing: "Fila {{row}}: no se encontró «{{name}}» para ponerlo dentro. Se guardó sin estar dentro de nada.",
importSitsInNotAllowed: "Fila {{row}}: no puede estar en «{{name}}» (un lugar solo en un lugar y un vehículo en nada). Se guardó sin estar dentro de nada.",
importFileUnreadableTitle: "No se pudo leer el archivo",
importFileUnreadable: "Guárdalo como CSV o Excel y vuelve a elegirlo.",
importFailed: "La importación se detuvo. Revisa tu archivo y selecciona Reintentar la importación.",
apiErrors: {
sessionExpired: "Tu sesión ya no es válida. Vuelve a iniciar sesión e inténtalo de nuevo.",
ownerOnly: "Solo el propietario del espacio de trabajo puede configurar integraciones, claves de API y acceso de IA. Pídele que lo haga.",
forbidden: "No tienes acceso para hacer esto.",
sourceInactive: "Este origen conectado no está activo. Reactívalo o renueva el token antes de volver a intentarlo.",
mcpAuth: "La conexión de IA no pudo iniciar sesión. Revisa su clave e inténtalo de nuevo.",
mcpUnreachable: "No se pudo contactar con el servidor MCP. Revisa la URL, las credenciales y el acceso a la red, e inténtalo de nuevo.",
sourceToken: "Este token de origen de datos no es válido para este espacio de trabajo.",
mcpRuntime: "La conexión de IA no pudo terminar. Revisa su dirección y su clave, e inténtalo de nuevo.",
mcpAdmin: "No se pudo actualizar la conexión de IA. Revisa los datos e inténtalo de nuevo.",
automationRun: "No se pudo completar la prueba o el reintento de la automatización. Revisa la configuración e inténtalo de nuevo.",
automationAdmin: "No se pudo guardar la automatización. Revisa lo que escribiste e inténtalo de nuevo.",
connectedIngest: "No se aceptó el mensaje del dispositivo. Revisa el token y las referencias de activos que envía, e inténtalo de nuevo.",
connectedAdmin: "No se pudo actualizar este origen de datos. Revisa el origen, la regla o el mensaje, e inténtalo de nuevo.",
workspaceAdmin: "No se pudo guardar este ajuste. Inténtalo de nuevo o pregunta al propietario del espacio de trabajo.",
generic: "No se pudo completar la solicitud. Inténtalo de nuevo.",
},
  importRetry: "Reintentar la importación",
  importExcelFeature: "Importación desde Excel",
  importRetrying: "Reintentando…",
  importStopped: "Detenido en la fila {{row}}: {{message}} Esa fila y las siguientes no se importaron.",
  importWizard: {
  step: {
  file: "Archivo",
  object: "Objeto",
  map: "Asignación",
  preview: "Vista previa",
  done: "Listo",
  },
  skip: "— Omitir —",
  noDefault: "— Sin valor predeterminado —",
  optionalDefault: "Valor predeterminado opcional…",
  sampleLeadDownload: "¿Primera importación? Descarga un ejemplo listo para usar (columnas y valores válidos).",
  sampleLeadCopy: "¿Primera importación? Copia un ejemplo listo para usar (columnas y valores válidos).",
  sampleAssetsDownload: "Descargar ejemplo de activos",
  sampleAssetsCopy: "Copiar ejemplo de activos",
  sampleContactsDownload: "Descargar ejemplo de contactos",
  sampleContactsCopy: "Copiar ejemplo de contactos",
  sampleAssetsA11yDownload: "Descargar CSV de ejemplo para importar activos",
  sampleAssetsA11yCopy: "Copiar CSV de ejemplo para importar activos",
  sampleContactsA11yDownload: "Descargar CSV de ejemplo para importar contactos",
  sampleContactsA11yCopy: "Copiar CSV de ejemplo para importar contactos",
  sampleCalloutDownload: "Hojas de cálculo de ejemplo: descarga los archivos de ejemplo del paso 1 o de abajo.",
  sampleCalloutCopy: "Hojas de cálculo de ejemplo: copia los archivos de ejemplo del paso 1 o de abajo.",
  formatReferenceShow: "Mostrar la referencia completa del formato de datos",
  formatReferenceHide: "Ocultar la referencia completa del formato de datos",
  },
webhookSecretIssued: "Se ha emitido una nueva credencial de webhook. Cópiala ahora — no se volverá a mostrar.",
webhookSecretReveal: "Mostrar",
webhookSecretHide: "Ocultar",
webhookSecretCopy: "Copiar",
webhookSecretCopied: "Copiado",
webhookSecretDismiss: "Descartar",
webhookSecretHiddenA11y: "Credencial de webhook, oculta. Usa Mostrar para verla.",
webhookSecretRevealedA11y: "Credencial de webhook, visible en pantalla.",
breadcrumb: "Cuenta · Espacio de trabajo · Integraciones",
breadcrumbShort: "Espacio de trabajo · Integraciones",
titleShort: "Centro de integraciones",
hintShow: "Consejos de la pestaña",
hintHide: "Ocultar consejos",
eyebrow: "Integraciones del espacio de trabajo",
title: "Integraciones listas para tu negocio",
metaLine: "Conecta tus herramientas empresariales con claves de API, webhooks y automatizaciones sencillas.",
contextHintApis: "Empieza por las API: crea claves seguras, revisa los ámbitos y abre la referencia de la API en directo.",
contextHintApisGateway: "Claves API y acceso: la administración usa su sesión iniciada a través de la puerta de enlace del espacio de trabajo. Cree claves paso a paso, verifique la conexión y abra la referencia en vivo.",
contextHintMcp: "MCP del espacio de trabajo: registra servidores externos aprobados, cifra las credenciales, descubre metadatos y mantén un historial de invocaciones auditable.",
contextHintImport: "Importación de datos: sube hojas de cálculo y asigna tus registros rápidamente.",
contextHintAutomations: "Disparadores de eventos: recetas e historial de ejecuciones. Cree cuentas de servicio y claves API en Claves API y acceso, no aquí.",
contextHintConnected: "La ingesta conectada tiene su propia pestaña: crea orígenes, rota los tokens de cada origen, revisa los eventos entrantes y las coincidencias sin resolver, y después configura reglas. Usa Claves de API y acceso solo cuando quieras una cuenta de servicio del espacio de trabajo en lugar del token de ingesta.",
contextHintConnectedShort: "Crea un origen, copia el token de un solo uso de la ventana emergente, envía JSON mediante POST a la URL de ingesta y después añade reglas opcionales. Las claves de cuenta de servicio están en Claves de API y acceso.",
connectedAssetsLink: "Activos conectados",
resourcesHelp: "Referencia de la API (en la app)",
mainTabImport: "Importación de datos",
mainTabAutomations: "Disparadores de eventos",
mainTabApisAccess: "Claves API y acceso",
mainTabMcp: "Servidores MCP",
mainTabConnected: "Ingesta conectada",
guidedCategory: {
workflow: "Flujos de trabajo cotidianos",
inspection: "Avisar a otro sistema sobre inspecciones",
job: "Avisar a otro sistema sobre órdenes de trabajo",
asset_sync: "Sincronización de activos",
inbound_webhook: "Recibir de otro sistema",
scheduled: "Según una programación",
outbound: "Pruebas",
},
journey: {
stage_choose: "Elegir",
stage_configure: "Configurar",
stage_authorise: "Autorizar",
stage_mapping: "Asignar",
stage_preview: "Vista previa",
stage_test: "Probar",
stage_activate: "Activar",
stage_monitor: "Supervisar",
stepCounter: "Paso {{current}} de {{total}}",
back: "Atrás",
next: "Continuar",
finish: "Finalizar",
close: "Cerrar",
loading: "Cargando…",
testing: "Procesando…",
succeeded: "Correcto",
failed: "Fallido",
requestId: "ID de solicitud",
retry: "Intentar de nuevo",
nameLabel: "Nombre de la conexión",
outcome_read: "Leer datos de AssetWRX",
outcome_read_desc: "El otro sistema extrae activos, inspecciones u órdenes de trabajo de AssetWRX.",
outcome_send: "Enviar datos a AssetWRX",
outcome_send_desc: "El otro sistema crea o actualiza registros en AssetWRX.",
outcome_listen: "Recibir eventos de AssetWRX",
outcome_listen_desc: "AssetWRX notifica al otro sistema cuando algo cambia.",
outcome_combination: "Una combinación",
outcome_combination_desc: "Bidireccional — lee, escribe y mantente sincronizado.",
createAccess: "Crear acceso seguro",
accessCreated: "Acceso seguro creado",
accessFailed: "No se pudo crear el acceso seguro",
keyExpiryLabel: "Caducidad de la clave",
keyExpiry30: "30 días",
keyExpiry90: "90 días",
keyExpiry365: "1 año",
keyExpiryNever: "Nunca",
apiKeyLabel: "Clave de API",
customScopesHint: "Activa solo el acceso que necesita esta conexión.",
elevatedScopeHelp: "¿Necesitas acceso sin restricciones? Revísalo y créalo en la consola avanzada.",
matchField: "Coincidencia de registros",
matchExternalId: "Asociar activos por ID externo",
idempotencyPolicy: "Los eventos de origen repetidos usan el mismo ID de evento de origen, por lo que los reintentos no generan trabajo duplicado.",
conflictPolicy: "Cuando ambos sistemas cambiaron un registro",
conflictPolicyNote: "Tu equipo de TI incorpora esta regla a la sincronización; AssetWRX la muestra en la página de la conexión. Para evitar duplicados, la sincronización busca cada activo por su ID externo antes de crearlo.",
conflict_manual_review: "Preguntar a una persona",
conflict_manual_review_desc: "Lo más seguro. Tu sistema no sobrescribe un registro que alguien cambió en AssetWRX; lo marca para que una persona lo revise.",
conflict_source_wins: "Tu sistema prevalece",
conflict_source_wins_desc: "Tu sistema actualiza el registro de AssetWRX que tiene el mismo ID externo.",
conflict_assetwrx_wins: "AssetWRX prevalece",
conflict_assetwrx_wins_desc: "Tu sistema deja como están los registros que se cambiaron en AssetWRX.",
previewTitle: "Revisar antes de probar",
previewHint: "Confirma el propósito de negocio, el acceso y las reglas de procesamiento. La prueba no activará la conexión.",
previewConnection: "Conexión",
previewAccess: "Acceso",
previewDestination: "Destino",
previewEvents: "Eventos",
previewScopeCount_one: "{{count}} ámbito de mínimo privilegio",
previewScopeCount_many: "{{count}} ámbitos de mínimo privilegio",
previewScopeCount_other: "{{count}} ámbitos de mínimo privilegio",
previewConflict: "Política de conflictos",
previewProviderDefault: "Valor predeterminado seguro del proveedor",
previewRetry: "Reintentos",
previewIdempotent: "Idempotente; los eventos duplicados se ignoran",
secretOnce: "Cópialo ahora — por tu seguridad, no se volverá a mostrar.",
secretSaved: "Lo he guardado de forma segura",
copy: "Copiar",
copied: "Copiado",
testConnection: "Probar conexión",
testStatusExplain: "Llamaremos al endpoint de estado de solo lectura con tu nueva clave para confirmar que funciona. No se crea ni cambia nada.",
connected: "Conectado",
connectedDetail: "AssetWRX aceptó las credenciales y respondió correctamente.",
connectionFailed: "Error de conexión",
quickStartExplain: "Apunta tu aplicación a esta URL base y envía tu clave en la cabecera x-asset-inspector-key.",
baseUrlLabel: "URL base",
firstRequestLabel: "Primera solicitud",
quickStartKeyNote: "Sustituye YOUR_API_KEY por la clave que acabas de guardar. Nunca la almacenamos en los ejemplos.",
ready: "Tu conexión está lista",
readyDetail: "Puedes gestionarla en cualquier momento desde Tus conexiones.",
activating: "Activándola…",
activateFailed: "Tu conexión aún no está activa",
activateFailedDetail: "Selecciona Intentar de nuevo. Todavía no se ha activado nada.",
done: "Hecho",
na_openGuides: "Abrir guías para desarrolladores",
na_openReference: "Abrir la referencia de la API",
na_setupEvents: "Configurar eventos",
na_createAutomation: "Crear automatización",
na_manageSource: "Gestionar origen y reglas",
identifierExplain: "Cada evento entrante debe indicar a qué activo pertenece. Elige cómo identificarán los activos tus dispositivos.",
idKind_external: "ID externo",
idKind_qr: "Código QR",
createSource: "Crear origen de datos",
sourceCreated: "Origen de datos creado",
sourceFailed: "No se pudo crear el origen de datos",
ingestTokenLabel: "Token de ingesta",
ingestAddressLabel: "Dirección a la que envían los dispositivos",
ingestHowTo: "Da al equipo de dispositivos esta dirección y el token de ingesta. Cada mensaje es un POST HTTPS a la dirección con el token en la cabecera x-connected-source-token.",
sendAnotherTest: "Probar otro identificador",
sendTestExplain: "Envía ahora un evento de prueba seguro. Opcionalmente, introduce uno de tus identificadores de activo reales para ver una coincidencia en vivo.",
testIdentifierLabel: "Identificador de activo (opcional)",
sendTestEvent: "Enviar evento de prueba",
eventMatched: "Evento recibido · activo encontrado",
eventMatchedDetail: "AssetWRX aceptó el evento y lo vinculó al activo coincidente.",
eventUnmatched: "Evento recibido · activo no identificado",
eventUnmatchedDetail: "El canal funciona — simplemente no pudimos asociar este identificador a un activo. Introduce un identificador de activo real o resuélvelo más tarde en Eventos conectados.",
eventFailed: "El evento fue rechazado",
title_business: "Conectar un sistema empresarial",
business_choose_title: "¿Qué vas a conectar?",
business_choose_hint: "Dale un nombre que reconozcas y elige el tipo de sistema.",
business_outcome_title: "¿Qué quieres que haga?",
business_outcome_hint: "Esto nos ayuda a recomendarte el acceso seguro adecuado.",
business_mapping_title: "Asignar registros y conflictos",
business_mapping_hint: "Usa identificadores externos estables y decide qué ocurre cuando ambos sistemas cambian un registro.",
business_access_title: "Crear acceso seguro",
business_access_hint: "AssetWRX crea una cuenta de servicio y una única clave de API para esta conexión.",
business_test_title: "Probar la conexión",
business_activate_title: "Finalizar",
sys_erp: "ERP",
sys_crm: "CRM",
sys_finance: "Finanzas",
sys_maintenance: "Mantenimiento",
sys_data: "Plataforma de datos",
sys_custom: "Aplicación personalizada",
sys_other: "Otro",
title_developer: "Crear una aplicación personalizada",
dev_choose_title: "Nombra tu aplicación",
dev_choose_hint: "Esto etiqueta la clave de API para que puedas encontrarla más tarde.",
dev_access_title: "Crear acceso seguro",
dev_access_hint: "Elige el acceso mínimo que necesita esta aplicación. El acceso sin restricciones está en la consola avanzada.",
dev_quickstart_title: "Realiza tu primera solicitud",
dev_activate_title: "Finalizar",
title_iot: "Conectar un origen de datos",
iot_choose_title: "Nombra el origen",
iot_choose_hint: "¿Qué está enviando datos a AssetWRX?",
iot_configure_title: "¿Cómo se identificarán los activos?",
iot_token_title: "Protege el origen",
iot_token_hint: "Los dispositivos envían este token en la cabecera x-connected-source-token.",
iot_test_title: "Envía el primer evento",
iot_activate_title: "Finalizar",
src_device: "Dispositivo / sensor",
src_gateway: "Pasarela IoT",
src_platform: "Plataforma IoT",
src_external: "Sistema externo",
title_webhook: "Crear una conexión de eventos",
wh_choose_title: "Nombra esta conexión de eventos",
wh_choose_hint: "Cuando ocurra algo en AssetWRX, ¿adónde debemos enviarlo?",
wh_configure_title: "Destino y eventos",
wh_secret_title: "Generar secreto de firma",
wh_test_title: "Enviar un evento de prueba",
wh_activate_title: "Activar",
destUrlLabel: "URL de destino",
destUrlError: "Introduce una URL https:// válida.",
chooseEvents: "¿Qué cambios debemos enviar?",
signingExplain: "Verifica esta firma en cada envío para confirmar que realmente proviene de AssetWRX.",
signingSecretLabel: "Secreto de firma",
generateSecret: "Generar secreto de firma",
webhookCreated: "Conexión de eventos creada",
webhookFailed: "No se pudo crear la conexión de eventos",
webhookTestExplain: "Envía ahora un envío de prueba firmado a tu endpoint para confirmar que puede recibir eventos.",
sendTestDelivery: "Enviar envío de prueba",
webhookTestSent: "Evento de prueba entregado",
webhookTestDetail: "Tu endpoint aceptó un envío firmado de {{event}}{{http}}.",
webhookTestRejected: "Tu endpoint no aceptó el evento de prueba",
webhookTestFailed: "No se pudo enviar el evento de prueba",
na_viewDeliveries: "Ver envíos",
evtgrp_assets: "Activos",
evt_asset_created: "Activo creado",
evt_asset_updated: "Activo actualizado",
evt_asset_deleted: "Activo eliminado",
evtgrp_inspections: "Inspecciones",
evt_inspection_created: "Inspección creada",
evt_inspection_updated: "Inspección actualizada",
evt_inspection_completed: "Inspección completada",
evtgrp_wrx: "WRX (órdenes de trabajo)",
evt_job_created: "WRX creado",
evt_job_status: "Estado de WRX cambiado",
evt_job_completed: "WRX completado",
evtgrp_contacts: "Contactos",
evt_contact_created: "Contacto creado",
evt_contact_updated: "Contacto actualizado",
evtgrp_connected: "Datos conectados",
evt_connected_received: "Evento conectado recibido",
evt_connected_unresolved: "Evento conectado sin coincidencia",
evt_connected_alert: "Alerta conectada generada",
title_automation: "Automatizar un proceso",
auto_choose_title: "¿Qué quieres automatizar?",
auto_choose_hint: "Elige un punto de partida. Podrás ajustarlo todo después.",
auto_configure_title: "Crear la automatización",
auto_configure_hint: "Unas pocas elecciones y luego lee la frase: eso es exactamente lo que ocurrirá.",
auto_test_title: "Probar la automatización",
auto_activate_title: "Finalizar",
tmpl_inspection_issue: "Cuando se completa una inspección",
tmpl_wrx_completed: "Cuando se completa un WRX",
tmpl_wrx_status: "Cuando cambia el estado de un WRX",
tmpl_asset_changed: "Cuando cambia un activo",
tmpl_scratch: "Empezar desde cero",
tmpl_inbound_webhook: "Cuando otro sistema llama a tu webhook",
tmpl_action_create_wrx: "Crear una solicitud de trabajo (WRX)",
tmpl_action_send_event: "Enviarlo a tu webhook",
tmpl_action_notify: "Notificar a otro sistema",
tmpl_action_choose: "Lo eliges en el generador",
tmpl_action_inbound_wrx: "Crear un WRX a partir de la solicitud",
automationCreateExplain: "Crearemos esta automatización como borrador. Añade las condiciones y acciones exactas en el generador y después actívala.",
createAutomation: "Crear automatización",
automationCreated: "Borrador de automatización creado",
automationFailed: "No se pudo crear la automatización",
automationTestExplain: "Ejecuta ahora la automatización una vez para confirmar que el desencadenador está bien configurado. Las automatizaciones en borrador no se ejecutan por sí solas.",
runTest: "Ejecutar prueba",
automationRan: "Ejecución de prueba completada",
automationRanDetail: "Estado de la ejecución: {{status}}. Añade acciones en el generador para que realice el trabajo.",
automationCreateExplain2: "Crearemos esta automatización con su desencadenador y una primera acción, lista para probar y activar.",
automationCreatedWithAction: "Automatización creada",
automationDraftDetail: "Añade en el generador las acciones que debe realizar.",
automationInboundReady: "A continuación se muestran la URL y el token del webhook entrante. Copia el token ahora.",
automationDestUrlLabel: "¿Adónde debemos enviarlo?",
automationDestUrlHint: "Enviamos mediante POST cada evento coincidente a esta URL HTTPS, firmado para que puedas verificarlo.",
automationInboundOnce: "Este es tu webhook entrante. Copia el token ahora, no se volverá a mostrar.",
automationInboundUrlLabel: "URL del webhook (envía el POST aquí)",
automationInboundTokenLabel: "Token secreto",
autoJobTitle: "Solicitud de trabajo automatizada",
automationRanDetail2: "Estado de la ejecución: {{status}}. Esto ejecutó la acción de la automatización una vez con datos de ejemplo.",
automationRunFailed: "La ejecución de prueba ha fallado",
na_openBuilder: "Abrir el generador de automatizaciones",
title_ai: "Conectar un agente de IA",
ai_choose_title: "Nombra la conexión de IA",
ai_choose_hint: "Por ejemplo, el asistente o agente que quieres conectar.",
ai_nameLabel: "Nombra esta conexión",
ai_modeLabel: "¿Cómo quieres conectarte?",
ai_modeFirstParty: "Permitir que un asistente de IA use AssetWRX",
ai_modeFirstPartyDesc: "Activa el servidor MCP de AssetWRX para que los asistentes aprobados puedan leer de forma segura y proponer acciones.",
ai_modeExternal: "Conectar un servidor MCP externo",
ai_modeExternalDesc: "Registra un servidor MCP de terceros mediante su URL para que AssetWRX pueda llamar a sus herramientas y recursos.",
mcpExternalExplain: "Introduce la URL HTTPS del servidor MCP y cómo debe autenticarse AssetWRX ante él.",
mcpBaseUrlLabel: "URL del servidor",
mcpAuthLabel: "Autenticación",
mcpAuthNone: "Sin autenticación",
mcpAuthBearer: "Token Bearer",
mcpAuthApiKey: "Clave de API",
mcpAuthCustom: "Cabecera personalizada",
mcpHeaderNameLabel: "Nombre de la cabecera",
mcpSecretPlaceholder: "Secreto / token",
mcpRegister: "Registrar servidor",
mcpRegistered: "Servidor externo registrado",
mcpRegisterFailed: "No se pudo registrar el servidor",
mcpNoKeyExplain: "Esta conexión usa las credenciales que acabas de introducir para el servidor externo. No se necesita ninguna clave de AssetWRX.",
mcpExternalTestExplain: "Nos conectaremos al servidor y listaremos las herramientas y recursos que expone.",
mcpTestConnection: "Probar conexión",
mcpTestFailed: "No se pudo contactar con el servidor",
mcpConnected: "Conectado al servidor",
mcpDiscovered: "Se encontraron {{tools}} herramientas y {{resources}} recursos.",
ai_enable_title: "Permitir acceso a la IA",
ai_access_title: "Elige el nivel de acceso",
ai_access_hint: "Elige qué puede ver y hacer la IA. Solo puede proponer cambios, que siguen necesitando confirmación.",
ai_test_title: "Verificar la conexión",
ai_activate_title: "Finalizar",
mcpExplain: "Los asistentes y agentes de IA aprobados pueden leer de forma segura la información seleccionada de AssetWRX y proponer acciones. Todo cambio propuesto por una IA sigue necesitando confirmación.",
mcpEndpointLabel: "Endpoint de conexión de IA",
enableAi: "Habilitar acceso a la IA",
mcpEnabled: "Acceso a la IA habilitado",
mcpEnableFailed: "No se pudo habilitar el acceso a la IA",
mcpVerifyExplain: "Confirmaremos que la clave funciona y que se puede contactar con el conector de IA. No se cambia nada.",
verifyAi: "Verificar conexión de IA",
mcpActive: "La conexión de IA está activa",
mcpDegraded: "Conexión de IA habilitada",
mcpVerifyDetail: "La clave funciona y el conector de IA respondió. Los agentes aprobados ya pueden conectarse.",
mcpVerifyFailed: "No se pudo verificar la conexión de IA",
na_reviewActivity: "Revisar la actividad de la IA",
title_files: "Configurar el intercambio de archivos",
files_choose_title: "Nombra esta conexión de archivos",
files_choose_hint: "Sube documentos y archivos a AssetWRX, o descárgalos, con enlaces seguros de corta duración.",
files_access_title: "Crear acceso seguro",
files_access_hint: "Operaciones de activos cubre la subida y descarga; Solo lectura cubre únicamente la descarga.",
files_test_title: "Probar el intercambio de archivos",
files_activate_title: "Finalizar",
na_openFilesGuide: "Abrir la guía de archivos",
filesReady: "El intercambio de archivos está listo",
filesReadOnlyDetail: "Esta clave puede descargar archivos pero no subirlos, así que comprobamos que inicia sesión. Los enlaces de descarga funcionan para los archivos que ya están en AssetWRX.",
filesReadyReadOnly: "El intercambio de archivos está listo (solo descarga)",
filesBothDetail: "Se emitieron correctamente los enlaces firmados de subida y descarga.",
filesUploadDetail: "Se emitió un enlace de subida firmado. Las descargas usan el mismo mecanismo de enlace seguro.",
filesTestFailed: "No se pudieron emitir enlaces firmados",
filesTestExplain: "Solicitaremos a AssetWRX un enlace de subida firmado de corta duración con tu nueva clave. No se sube nada — esto solo demuestra que la conexión puede mover archivos.",
filesObjectKey: "Clave de objeto de ejemplo",
filesTest: "Probar el intercambio de archivos",
automationScratchExplain: "Crearemos una automatización vacía que podrás construir en el editor avanzado.",
automationEventReady: "Lista para ejecutarse por sí sola",
automationEventTestExplain: "Esta se ejecuta sola cuando el espacio de trabajo hace lo que vigila. No hay que pulsar nada — verás cada ejecución en su historial.",
},
home: {
eyebrow: "Integraciones del espacio de trabajo",
title: "¿Qué quieres conseguir?",
subtitle: "Elige el resultado de negocio. AssetWRX guiará la configuración segura, la prueba y la activación.",
resumeTitle: "Reanudar configuración",
discardDraft: "Descartar configuración guardada",
card_business_title: "Conectar otro sistema empresarial",
card_business_desc: "Conecta un ERP, CRM, plataforma financiera, sistema de mantenimiento u otra aplicación empresarial.",
card_business_cta: "Conectar un sistema",
card_webhook_title: "Reaccionar cuando ocurra algo",
card_webhook_desc: "Envía eventos a otro sistema cuando cambia un activo, una inspección, un trabajo o una solicitud.",
card_webhook_cta: "Crear conexión de eventos",
card_automation_title: "Automatizar un proceso",
card_automation_desc: "Realiza acciones automáticamente cuando ocurra algo en AssetWRX u otro sistema conectado.",
card_automation_cta: "Crear automatización",
card_iot_title: "Conectar sensores y dispositivos",
card_iot_desc: "Lleva a AssetWRX las lecturas de sensores y dispositivos y vincúlalas al activo correcto.",
card_iot_cta: "Conectar un origen de datos",
card_ai_title: "Conectar un agente de IA",
card_ai_desc: "Permite que los asistentes y agentes de IA aprobados trabajen de forma segura con AssetWRX.",
card_ai_cta: "Conectar IA",
card_developer_title: "Crear una aplicación personalizada",
card_developer_desc: "Usa la API de AssetWRX para crear aplicaciones e integraciones personalizadas.",
card_developer_cta: "Empezar a crear",
card_files_title: "Intercambiar archivos",
card_files_desc: "Sube documentos y archivos a AssetWRX, o descárgalos, mediante enlaces seguros de corta duración.",
card_files_cta: "Configurar el intercambio de archivos",
card_import_title: "Importar registros desde una hoja de cálculo",
card_import_desc: "Importa activos o contactos desde un archivo CSV o Excel. Asigna tus columnas a los campos correctos, previsualiza y crea los registros.",
card_import_cta: "Importar desde un archivo",
card_power_bi_title: "Informes en Power BI",
card_power_bi_desc: "Cargue activos, inspecciones y trabajos en Power BI o Excel, actualizados según su programación.",
card_power_bi_cta: "Configurar Power BI",
card_power_automate_title: "Usar Power Automate",
card_power_automate_desc: "Inicie flujos de Microsoft cuando cambie el trabajo y cree órdenes de trabajo e inspecciones desde sus flujos.",
card_power_automate_cta: "Configurar Power Automate",
tier_start_title: "Empieza de forma sencilla",
tier_start_subtitle: "Guiado paso a paso. Algunos te dan una clave para pasar a quien gestiona el otro sistema.",
tier_data_title: "Datos, eventos y automatización",
tier_data_subtitle: "Mueve datos, reacciona a los cambios y automatiza el trabajo.",
tier_dev_title: "Desarrollador e IA",
tier_dev_subtitle: "Crea sobre la API y conecta agentes de IA.",
connectionsTitle: "Tus conexiones",
connectionsEmptyTitle: "Aún no hay conexiones",
connectionsEmptyDesc: "Elige un resultado arriba para conectar tu primer sistema.",
connectionsEmptyMember: "El propietario del espacio de trabajo configura las conexiones.",
connectionsLoadFailed: "No se pudieron cargar tus conexiones.",
connectionsRetry: "Intentar de nuevo",
lockedSubtitle: "Conecta otros sistemas, automatiza el trabajo y vincula sensores o agentes de IA.",
activityNever: "Aún no hay actividad",
status_draft: "Borrador",
status_testing: "En pruebas",
status_active: "Activa",
status_paused: "Pausada",
status_error: "Requiere atención",
status_archived: "Inactiva",
devToolsTitle: "Herramientas para desarrolladores",
dev_api_title: "Referencia de la API",
dev_api_subtitle: "Consulta la referencia de REST y GraphQL en directo.",
dev_docs_title: "Guías y documentación",
dev_docs_subtitle: "Guías por tareas, ejemplos y solución de problemas.",
dev_advanced_title: "Consola avanzada",
dev_advanced_subtitle: "Todas las claves, el acceso de IA, las automatizaciones y los datos entrantes, en un solo lugar.",
dev_keys_title: "Claves de API",
dev_keys_subtitle: "Crea, rota y revoca las claves que usan tus integraciones.",
dev_ai_title: "Acceso de asistentes de IA",
dev_ai_subtitle: "Elige qué pueden ver y hacer los asistentes de IA externos, y aprueba sus cambios.",
devTitle: "Conecta, crea y automatiza",
devSectionTitle: "Desarrollador y referencia",
devSectionSubtitle: "Para equipos que conectan sistemas directamente, dan acceso a asistentes de IA o gestionan claves.",
devSectionSubtitleApi: "Para equipos que conectan sistemas directamente o gestionan claves.",
devSectionSubtitleMcp: "Para equipos que dan acceso a asistentes de IA, con guías paso a paso.",
devSectionSubtitleGuides: "Guías, ejemplos y solución de problemas para sus integraciones.",
journeyUnavailableTitle: "Aún no disponible",
journeyUnavailableDesc: "Este proceso se está configurando. Vuelve a consultarlo en breve.",
},
connection: {
type_business_system: "Sistema empresarial",
type_event_webhook: "Webhook",
type_automation: "Automatización",
type_iot_connected: "Sensores e IoT",
type_ai_mcp: "Agente de IA",
type_developer_app: "Aplicación personalizada",
type_file_exchange: "Intercambio de archivos",
overview: "Resumen",
lastActivity: "Última actividad",
source: "Origen",
sourceManaged: "Conexión gestionada",
sourceDerived: "Derivada de un recurso existente",
whatsConnected: "Qué está conectado",
noResources: "Sin recursos vinculados.",
activity: "Actividad reciente",
activityEmpty: "Aún no hay actividad reciente que mostrar.",
health_healthy: "Correcto",
health_attention: "Requiere atención",
health_inactive: "Inactivo",
health_active: "Activo",
health_degraded: "Degradado",
health_paused: "Pausado",
health_revoked: "Revocado",
healthTitle: "Estado de la conexión",
lastSuccess: "Último éxito",
lastFailure: "Último fallo",
noFailure: "Ninguno registrado",
affectedObjects: "Objetos afectados",
recovery_manage: "Gestionar conexión",
recovery_recover: "Revisar el fallo y reconectar",
recovery_resume: "Reanudar conexión",
recovery_review_history: "Revisar historial de acceso",
notFoundTitle: "Conexión no encontrada",
notFoundDesc: "Puede que se haya eliminado. Vuelve al inicio de integraciones.",
actionFailed: "No se pudo actualizar la conexión.",
archiveTitle: "¿Revocar el acceso de la conexión?",
archiveMsg: "El acceso se detendrá de inmediato. La configuración y el historial de actividad seguirán disponibles para auditoría.",
archive: "Revocar acceso",
pause: "Pausar",
activate: "Activar",
openAdvanced: "Abrir en la consola avanzada",
kind_service_account: "Clave de API",
kind_webhook_subscription: "Conexión de eventos (webhook)",
kind_connected_source: "Origen de datos conectado",
kind_mcp_server: "Servidor de IA / MCP",
kind_automation_recipe: "Receta de automatización",
},
docs: {
title: "Guías y documentación",
subtitle: "Guías por tareas, ejemplos funcionales y solución de problemas.",
notFound: "Guía no encontrada",
achieve: "Qué conseguirás",
need: "Qué necesitas",
steps: "Pasos",
verify: "Cómo saber que ha funcionado",
failure: "Si falla",
next: "Qué hacer a continuación",
rawHandbook: "Manual sin procesar (avanzado)",
minutes_one: "{{count}} min",
minutes_many: "{{count}} min",
minutes_other: "{{count}} min",
minutesRead_one: "{{count}} min de lectura",
minutesRead_many: "{{count}} min de lectura",
minutesRead_other: "{{count}} min de lectura",
section: {
gettingStarted: { title: "Primeros pasos", description: "Conecta tu primer sistema y haz tu primera llamada." },
guides: { title: "Guías", description: "Conecta sistemas y plataformas habituales, paso a paso." },
api: { title: "API", description: "REST, GraphQL, autenticación, errores e identificadores de solicitud." },
events: { title: "Eventos", description: "Webhooks salientes, firmas, reintentos e idempotencia." },
automation: { title: "Automatización", description: "Disparadores, condiciones y acciones." },
connected: { title: "Datos conectados", description: "Envía datos de dispositivos y sensores y vincúlalos a los activos." },
aiMcp: { title: "IA y MCP", description: "Deja que agentes de IA aprobados trabajen con AssetWRX de forma segura." },
security: { title: "Seguridad", description: "Mínimo privilegio, rotación de claves e historial de auditoría." },
troubleshooting: { title: "Solución de problemas", description: "Resuelve los problemas de integración más comunes según el síntoma." },
},
guide: {
integrationOverview: { title: "Resumen de las integraciones", summary: "Cómo se conecta AssetWRX con otros sistemas." },
connectFirstSystem: { title: "Conecta tu primer sistema", summary: "Crea un acceso seguro y comprueba que funciona." },
authentication: { title: "Autenticación", summary: "Cómo autenticar las solicitudes a la API." },
makeFirstRequest: { title: "Haz tu primera solicitud a la API", summary: "Llama a la API y lee una respuesta correcta." },
connectErp: { title: "Conectar un ERP", summary: "Da a tu ERP (u otro sistema de negocio) su propio acceso seguro a AssetWRX y deja que TI termine la parte del ERP.", time: "20 min, más el tiempo de TI" },
connectPowerAutomate: { title: "Conectar Power Automate", summary: "Crea trabajos e inspecciones de AssetWRX desde tus flujos de Microsoft e inicia un flujo cuando algo cambie en AssetWRX." },
connectPowerBi: { title: "Informes en Power BI", summary: "Lleva tus activos, inspecciones y trabajos a Power BI o Excel, actualizados según una programación." },
embedInAPortal: { title: "Mostrar AssetWRX dentro de otro portal", summary: "Coloca pantallas de AssetWRX (Trabajo, un activo, una inspección, una orden de trabajo) dentro de tu portal de clientes o intranet.", time: "15 min para ti, más tu equipo web" },
embedInDynamics: { title: "Mostrar AssetWRX en Dynamics 365", summary: "El activo de AssetWRX en el formulario Customer Asset de Dynamics 365, con inicio de sesión de Microsoft, que actualiza el formulario al terminar el trabajo.", time: "30 min para ti, alrededor de una hora para TI" },
sendIotData: { title: "Enviar datos de sensores y dispositivos", summary: "Deja que sensores, pasarelas u otro sistema envíen lecturas y alertas a AssetWRX, vinculadas al activo correcto.", time: "15 min, más el tiempo del equipo de dispositivos" },
receiveEvents: { title: "Recibir eventos de AssetWRX", summary: "Haz que AssetWRX envíe un mensaje a otro sistema cuando cambie un activo, una inspección, un trabajo o una solicitud.", time: "15 min, más el tiempo de TI" },
connectAiAgent: { title: "Conectar un agente de IA", summary: "Deja que un asistente de IA aprobado lea tu información de AssetWRX y pida cambios que aprueba una persona.", time: "15 min, más la configuración de la herramienta de IA" },
uploadDownloadFiles: { title: "Subir y descargar archivos", summary: "Deja que otro sistema envíe archivos a AssetWRX y los recupere, con enlaces seguros de corta duración.", time: "10 min, más el tiempo de TI" },
restApi: { title: "API REST", summary: "Recursos, métodos y formatos." },
paginationErrors: { title: "Paginación, errores e identificadores de solicitud", summary: "Lee listas página a página y diagnostica fallos." },
permissionsScopes: { title: "Permisos y ámbitos", summary: "Qué permite cada ámbito." },
webhooks: { title: "Webhooks salientes", summary: "Cómo funcionan los envíos salientes." },
signatureVerification: { title: "Verificación de firmas", summary: "Confirma que un envío viene realmente de AssetWRX." },
automationGettingStarted: { title: "Automatización: primeros pasos", summary: "Disparadores, condiciones y acciones." },
assetMatching: { title: "Coincidencia de activos", summary: "Cómo se vinculan los eventos a los activos." },
unresolvedEvents: { title: "Eventos sin resolver", summary: "Corrige los eventos que no coincidieron con ningún activo." },
mcpOverview: { title: "Resumen de IA y MCP", summary: "Cómo funcionan las conexiones de IA." },
mcpSecurity: { title: "Seguridad de la IA y modelo de aprobación", summary: "Mantén seguro el acceso de la IA." },
leastPrivilege: { title: "Mínimo privilegio", summary: "Concede solo lo que necesita una conexión." },
keyRotation: { title: "Rotación y revocación de claves", summary: "Sustituye o desactiva claves de forma segura." },
auditHistory: { title: "Historial de auditoría", summary: "Mira quién hizo qué." },
apiRejected: { title: "Mi llamada a la API es rechazada", summary: "Errores 401 / 403 y de validación." },
webhookNotArriving: { title: "Mi webhook no llega", summary: "Los envíos nunca llegan a tu punto de conexión." },
eventNoAsset: { title: "Mi evento no encuentra un activo", summary: "Los eventos conectados quedan sin resolver." },
automationDidNotRun: { title: "Mi automatización no se ejecutó", summary: "Una receta no se activó." },
aiCannotConnect: { title: "Mi agente de IA no se conecta", summary: "La conexión de IA falla." },
},
},
access: {
title: "Acceso seguro",
notFound: "La cuenta de servicio de esta conexión no está disponible.",
keyCount: "{{active}} clave(s) activa(s)",
statusActive: "Activa",
statusRevoked: "Revocada",
permissions: "Permisos",
keys: "Claves de API",
keyLine: "{{scopeCount}} ámbitos · creada el {{created}}",
expires: "caduca",
rotate: "Rotar clave",
rotateFailed: "No se pudo rotar la clave.",
revokeFailed: "No se pudo revocar. La clave sigue funcionando.",
revoke: "Revocar",
rotateTitle: "¿Renovar esta clave?",
rotateMsg: "La clave actual deja de funcionar ahora. Introduce la nueva clave en Power BI, Power Automate o tu sistema de inmediato.",
revokeKeyTitle: "¿Revocar esta clave?",
revokeKeyMsg: "Las llamadas que la usan dejan de funcionar de inmediato.",
revokeAll: "Revocar acceso",
revokeAllTitle: "¿Revocar todo el acceso?",
revokeAllMsg: "La cuenta de servicio y todas las claves se revocan de inmediato. Esta acción no se puede deshacer.",
done: "Lo he guardado",
},
connected: {
title: "Ingesta conectada",
notFound: "El origen de datos de esta conexión no está disponible.",
statusActive: "Activo",
statusPaused: "Pausado",
statusDisabled: "Deshabilitado",
tokenEnding: "Token terminado en {{last}}",
rotateToken: "Rotar token de ingesta",
rotateFailed: "No se pudo rotar el token.",
pause: "Pausar",
resume: "Reanudar",
resolveFailed: "No se pudo resolver el evento.",
unresolvedTitle: "Requiere atención",
unresolvedEmpty: "No hay eventos sin resolver.",
reasonAmbiguous: "Coincidió con más de un activo",
reasonNoMatch: "Sin activo coincidente",
resolveWith: "Resolver como",
resolveInAdvanced: "Resolver en la consola avanzada",
rulesTitle: "Reglas",
rulesEmpty: "Aún no hay reglas.",
manageRules: "Gestionar reglas",
cancel: "Cancelar",
newRule: "+ Nueva regla",
ruleNameLabel: "Nombre de la regla (opcional)",
ruleNamePlaceholder: "p. ej. Alerta de temperatura alta",
matchLabel: "¿Qué eventos?",
matchAll: "Todos los eventos",
matchPrefix: "Empieza por",
actionLabel: "Entonces",
actionAlert: "Generar una alerta",
actionReposition: "Actualizar la ubicación",
actionPublish: "Publicar un evento",
actionJob: "Crear un WRX",
actionValueLabel: "Detalle de la acción",
valueAlertPlaceholder: "Título de la alerta (opcional)",
valueJobPlaceholder: "Título del WRX (opcional)",
createRule: "Crear regla (pausada)",
ruleCreateFailed: "No se pudo crear la regla.",
ruleUpdateFailed: "No se pudo actualizar la regla.",
ruleActivate: "Activar",
rulePause: "Pausar",
ruleAdvancedNote: "¿Necesitas condiciones o una lista de control? Abre la consola avanzada.",
eventsTitle: "Eventos recientes",
eventsEmpty: "Aún no se han recibido eventos.",
reprocess: "Reprocesar",
reprocessFailed: "No se pudo reprocesar el evento.",
},
automation: {
title: "Automatización",
notFound: "La automatización de esta conexión no está disponible.",
status_active: "Activa",
status_paused: "Pausada",
status_draft: "Borrador",
status_archived: "Archivada",
trigger: "Desencadenador",
steps_one: "{{count}} acción",
steps_many: "{{count}} acciones",
steps_other: "{{count}} acciones",
runResult: "Ejecución de prueba: {{status}}",
runFailed: "No se pudo ejecutar la automatización.",
activate: "Activar",
pause: "Pausar",
runNow: "Ejecutar ahora",
editInBuilder: "Editar en el generador",
actionFailed: "La acción ha fallado.",
historyTitle: "Historial de ejecuciones",
historyEmpty: "Aún no hay ejecuciones.",
retry: "Reintentar",
inboundTitle: "Webhook entrante",
inboundUrl: "URL del webhook (envía el POST aquí)",
inboundNone: "Genera un secreto para activar la URL entrante.",
inboundToken: "Token secreto (se muestra una sola vez)",
rotateSecret: "Rotar secreto",
lastRun: "Última ejecución",
never: "Nunca",
nextRun: "Próxima ejecución",
testRun: "Ejecución de prueba",
turnOn: "Activar",
edit: "Editar",
hideSkipped: "Ocultar omitidas",
showSkipped_one: "{{count}} omitida",
showSkipped_other: "{{count}} omitidas",
historyEmptyEvent: "Todavía no ha ocurrido nada — se ejecuta sola cuando el espacio de trabajo actúa.",
historyOnlySkipped: "Todas las ejecuciones hasta ahora se han omitido.",
fix: "Corregir esta automatización",
showSkipped_many: "{{count}} omitidas",
},
mcp: {
title: "Conexión de IA (MCP)",
notFound: "El servidor MCP de esta conexión no está disponible.",
statusActive: "Activo",
statusDisabled: "Deshabilitado",
statusError: "Error",
toolsResources: "{{tools}} herramientas · {{resources}} recursos",
test: "Probar conexión",
testOk: "Conectado · {{protocol}}",
testFail: "Error de conexión",
discover: "Descubrir metadatos",
discovered: "{{tools}} herramientas · {{resources}} recursos",
discoverFailed: "No se pudieron descubrir los metadatos.",
enable: "Habilitar",
disable: "Deshabilitar",
invocationsTitle: "Actividad reciente",
invocationsEmpty: "Aún no hay actividad.",
manageAdvanced: "Gestionar en la consola avanzada",
actionFailed: "La acción ha fallado.",
credentials: "Credenciales",
credentialsTitle: "Actualizar credenciales",
credentialsSaved: "Credenciales actualizadas",
credentialsFailed: "No se pudieron actualizar las credenciales.",
auth_none: "Sin autenticación",
auth_bearer: "Bearer",
auth_api_key: "Clave de API",
auth_custom_header: "Cabecera personalizada",
headerName: "Nombre de la cabecera",
secretPlaceholder: "Secreto / token",
saveCredentials: "Guardar credenciales",
},
files: {
  title: "Archivos intercambiados",
  empty: "Aún no hay archivos. Los archivos que tus sistemas suban a este espacio de trabajo, por cualquier conexión de archivos, aparecen aquí.",
  loadFailed: "No se pudieron cargar los archivos.",
  download: "Descargar",
  downloadFailed: "No se pudo descargar el archivo.",
},
webhook: {
  title: "Eventos",
  unavailable: "No se pudo cargar la suscripción de eventos de esta conexión.",
  address: "Envía a",
  secretEnding: "Secreto de firma que termina en {{last}}",
  secretLabel: "Secreto de firma",
  replace: "Sustituir el secreto de firma",
  replaceTitle: "¿Sustituir el secreto de firma?",
  replaceMsg: "Los eventos se firman con el nuevo secreto de inmediato, así que el sistema receptor los rechaza hasta tener el nuevo. Entrégaselo enseguida.",
  replaceFailed: "No se pudo sustituir el secreto de firma.",
},
embeddedApps: {
  refusal_other: "algo falló al iniciar la sesión. Inténtalo de nuevo; si se repite, contacta con el soporte de AssetWRX.",
  refusal_assertion: "no se aceptó la prueba de identidad que envió el portal. Pide a tu equipo de TI que revise los ajustes de inicio de sesión.",
  refusal_scope_denied: "el portal pidió algo que esta aplicación no puede hacer.",
  refusal_jit_refused: "no se pudo añadir a la persona automáticamente.",
  refusal_unknown_user: "la persona no está vinculada a nadie en este espacio de trabajo.",
  refusal_jit_domain_refused: "el dominio del correo de la persona no está en la lista permitida.",
  refusal_identity_unlinked: "un administrador desvinculó a esta persona. Vuelve a vincularla abajo.",
  refusal_identity_collision: "ese inicio de sesión ya pertenece a otra persona aquí.",
  refusal_user_disabled: "la cuenta de AssetWRX de la persona está desactivada.",
  refusal_wrong_tenant: "la persona usó una cuenta de Microsoft de otra empresa.",
  refusal_sso_required: "la persona no inició sesión con Microsoft.",
  refusal_not_entitled: "el plan del espacio de trabajo no incluye la integración.",
  refusal_view_not_permitted: "la vista necesita un permiso que esta aplicación no tiene.",
  refusal_not_a_member: "la persona no es miembro de este espacio de trabajo.",
  refusal_bootstrap_expired: "la persona tardó más de un minuto en iniciar sesión. Recargar la página del portal lo soluciona.",
  lastRefusalReason: "Último rechazo: {{reason}}",
  viewNeedsScope: "Estas vistas no se pueden abrir hasta que marques su permiso en «Qué puede hacer»: {{views}}.",
  viewsHelp: "Al marcar una vista también se marca el permiso que necesita en «Qué puede hacer».",
  disableMsg: "Todos los portales que la usan dejan de mostrar AssetWRX al momento y las sesiones abiertas terminan. Puedes volver a activarla cuando quieras.",
  disableTitle: "¿Desactivar {{name}}?",
  removeOriginConfirm: "Quitar sitio",
  removeOriginMsg: "Ese sitio deja de mostrar AssetWRX al momento. Quienes lo usen allí verán un espacio vacío hasta que vuelvas a añadirlo.",
  removeOriginTitle: "¿Quitar {{origin}}?",
  removeOriginShort: "Quitar",
  outcomeCta: "Configurar una aplicación integrada",
  outcomeTitle: "Mostrar AssetWRX en otro portal",
  ownerOnlyBodyUnnamed: "Pide al propietario de tu espacio de trabajo que añada una. Las guías de arriba muestran lo que necesitará.",
  ownerOnlyBody: "Pide a {{owner}} que añada una. Las guías de arriba muestran lo que necesitará.",
  ownerOnlyTitle: "Solo el propietario del espacio de trabajo puede configurar las aplicaciones integradas",
title: "Aplicaciones integradas",
subtitle: "Muestre AssetWRX dentro de otro portal, como Dynamics 365 o un portal de clientes. Elija qué sitios pueden alojarlo, qué vistas pueden abrir y qué pueden hacer esas vistas.",
cardSubtitle: "Muestre vistas de AssetWRX dentro de otro portal.",
guidePortal: "Cómo configurarlo",
guideDynamics: "Configurar Dynamics 365",
create: "Nueva aplicación integrada",
defaultName: "Aplicación integrada",
loadFailed: "No se pudieron cargar tus aplicaciones integradas. No se han modificado.",
emptyTitle: "Aún no hay aplicaciones integradas",
emptyDesc: "Cree una para elegir qué portal puede alojar AssetWRX y qué puede mostrar.",
adminOnly: "Solo los propietarios y administradores del espacio de trabajo pueden gestionar las aplicaciones integradas.",
name: "Nombre",
save: "Guardar",
statusActive: "Activada",
statusDisabled: "Desactivada",
enable: "Activar",
disable: "Desactivar",
publicId: "ID público",
publicIdHelp: "El portal anfitrión envía este ID. No es secreto y por sí solo no concede nada.",
secretTitle: "Secreto del anfitrión",
secretHelp: "El servidor de su portal lo usa para iniciar sesiones integradas. Guárdelo en el servidor, nunca en una página web.",
secretNone: "Aún no hay secreto. El portal no puede abrir AssetWRX hasta que cree uno.",
secretSet: "Secreto {{prefix}}… creado el {{date}}",
secretCreate: "Crear secreto",
secretRotate: "Sustituir secreto",
secretRotateTitle: "¿Sustituir el secreto del anfitrión?",
secretRotateMsg: "El secreto actual deja de funcionar de inmediato. Actualice el servidor de su portal con el nuevo.",
secretShownOnce: "Cópielo ahora. No se volverá a mostrar.",
origins: "Sitios permitidos",
originsHelp: "Solo direcciones exactas, como https://contoso.crm.dynamics.com. No se permiten comodines.",
originPlaceholder: "https://example.com",
addOrigin: "Añadir sitio",
removeOrigin: "Quitar {{origin}}",
noOrigins: "Aún no hay sitios. Nada puede alojar esta aplicación hasta que añada uno.",
originErrorWildcard: "No se permiten comodines. Añada cada sitio por separado.",
originErrorInvalid: "Introduzca una dirección como https://portal.example.com, sin ruta.",
views: "Vistas que puede abrir",
scopes: "Qué puede hacer",
interactiveOff: "Cambiar datos requiere integraciones interactivas en su plan. Hasta entonces, solo se aplica la visualización.",
userCeiling: "Nadie obtiene más que su propio acceso a AssetWRX.",
identityTitle: "Inicio de sesión",
identityModeAssetwrx: "Inicio de sesión de AssetWRX",
identityModeSso: "SSO de Microsoft Entra",
identityModeHost: "Proporcionado por el host (empresa)",
identityHelp_assetwrx: "Las personas inician sesión en AssetWRX dentro del portal con su propia cuenta de AssetWRX.",
identityHelp_sso: "Las personas inician sesión con la cuenta de Microsoft de su organización, en el inquilino indicado. Se rechazan otras cuentas y otros inquilinos.",
identityHelp_host: "El servidor del portal avala a la persona con un token de identidad firmado por su proveedor de identidad, sin un segundo inicio de sesión. La persona debe estar vinculada a este espacio de trabajo o añadirse automáticamente.",
idpEntra: "Microsoft Entra ID",
idpOidc: "Otro proveedor de OpenID Connect",
idpTenant: "ID de inquilino de Entra",
idpTenantHelp: "El ID de directorio (inquilino) de la organización. Se rechazan los inicios de sesión de cualquier otro inquilino.",
idpIssuer: "Emisor",
idpIssuerHelp: "La dirección web que identifica a tu proveedor de inicio de sesión. Tu equipo de TI la copia de los ajustes del proveedor. Empieza por https://.",
idpAudience: "Audiencia",
idpAudienceHelp: "El ID de aplicación que tu portal usa con el proveedor de inicio de sesión. Tu equipo de TI lo copia del registro de la aplicación en el proveedor.",
jitEnable: "Añadir personas nuevas automáticamente",
jitHelp: "Desactivado: solo las personas ya vinculadas o que ya son miembros pueden abrir la vista del portal. Activado: las personas del proveedor de identidad se unen a este espacio de trabajo la primera vez que llegan. Una dirección de correo que ya tiene una cuenta de AssetWRX nunca se vincula automáticamente.",
jitDomains: "Dominios de correo permitidos",
jitDomainsHelp: "Sepárelos con comas. Déjelo vacío para permitir a cualquier persona que inicie sesión con el proveedor de identidad.",
jitTeam: "Equipo para personas nuevas",
jitRole: "Las personas nuevas se unen como miembros, nunca como administradores.",
sessionLifetime: "Duración de la sesión",
hoursShort: "{{count}} h",
identitySave: "Guardar la configuración de inicio de sesión",
identityStats: "Sesiones abiertas: {{sessions}} · Personas vinculadas: {{identities}} · Rechazos (30 días): {{denied}}",
lastDenied: "último rechazo el {{date}}",
linkedIdentities: "Personas vinculadas",
noLinkedIdentities: "Todavía no hay nadie vinculado.",
linkedVia_admin: "Vinculada por un administrador",
linkedVia_jit: "Añadida automáticamente",
linkedVia_sso: "Inicio de sesión de Microsoft",
unlink: "Desvincular",
unlinkTitle: "¿Desvincular a esta persona?",
unlinkMsg: "Sus sesiones integradas terminan ahora, y el proveedor de identidad no podrá volver a iniciar su sesión aquí hasta que se vincule de nuevo.",
linkSubject: "ID de usuario del proveedor de identidad",
linkSubjectHelp: "El ID de la persona en tu proveedor de inicio de sesión (en Microsoft Entra, su ID de objeto en la página del usuario). Después elige el miembro abajo.",
link: "Vincular",
theme: "Apariencia",
themeAssetwrx: "AssetWRX",
themeHost: "Como el anfitrión",
themeLight: "Claro",
themeDark: "Oscuro",
viewWork: "Trabajo",
viewAssets: "Activos",
viewAsset: "Activo",
viewInspection: "Inspección",
viewJob: "Orden de trabajo",
viewRequest: "Solicitud",
viewInspectionReport: "Informe de inspección",
viewJobReport: "Informe de la orden de trabajo",
created: "Creada el {{date}}",
lastUsed: "Último uso {{date}}",
neverUsed: "Nunca usada",
delete: "Eliminar",
deleteTitle: "¿Eliminar {{name}}?",
deleteMsg: "Los portales que la usan dejan de funcionar de inmediato. Esto no se puede deshacer.",
cancel: "Cancelar",
actionFailed: "No se guardó. Inténtelo de nuevo.",
},
apiKeys: {
create: "Crear clave de API",
defaultName: "Clave de API",
createFailed: "No se pudo crear la clave. {{message}}",
address: "Dirección de la API",
howPowerBi: "En Power BI elige Obtener datos → Fuente OData, introduce {{url}}/v1/odata y luego Básica: cualquier nombre de usuario y esta clave como contraseña.",
howHeader: "Envía la clave en el encabezado x-asset-inspector-key en cada solicitud.",
openGuide: "Abrir la guía de configuración",
done: "Listo",
nameLabel: "Nombre",
createButton: "Crear clave",
manage: "Rotar o revocar",
hide: "Ocultar",
},
serviceAccounts: {
title: "Claves de API",
subtitle: "Crea una clave para Power BI, Power Automate o tu propio sistema y rótala o revócala aquí. Una clave se muestra una sola vez.",
emptyTitle: "Aún no hay claves de API",
emptyDesc: "Crea una clave con «Crear clave de API» o desde cualquier recorrido de conexión.",
revokeTitle: "¿Revocar este acceso?",
revokeMsg: "La cuenta de servicio y todas las claves se revocan de inmediato. Esta acción no se puede deshacer.",
lastUsed: "Usada por última vez el {{date}}",
neverUsed: "Nunca usada",
created: "creada el {{date}}",
},
aiSettings: {
title: "IA de AssetWRX (MCP)",
subtitle: "Controla lo que los asistentes de IA aprobados pueden hacer con AssetWRX. Todo cambio propuesto por una IA sigue necesitando confirmación.",
exposure: "Acceso a la IA",
statusEnabled: "Habilitado",
statusDisabled: "Deshabilitado",
enable: "Habilitar acceso a la IA",
disable: "Deshabilitar",
endpointLabel: "Endpoint MCP",
approvalsLoadFailed: "No se pudieron cargar las solicitudes de IA pendientes de aprobación.",
ttlLabel: "Caducidad de la propuesta",
ttlHours_one: "{{count}} hora",
ttlHours_many: "{{count}} horas",
ttlHours_other: "{{count}} horas",
ttlHour: "1 hora",
toolsTitle: "Herramientas",
toolsEmpty: "No hay herramientas disponibles.",
writeAction: "Puede hacer cambios (necesita confirmación)",
rowEnable: "Habilitar",
rowDisable: "Deshabilitar",
resourcesTitle: "Recursos",
resourcesEmpty: "No hay recursos disponibles.",
activityTitle: "Actividad reciente de la IA",
activityEmpty: "Aún no hay actividad de la IA.",
actionFailed: "No se pudo actualizar. Inténtalo de nuevo.",
},
connectedPanel: {
eyebrow: "Activos conectados",
title: "Ingesta de eventos conectados",
subtitle: "Gestiona orígenes, revisa el tráfico entrante, resuelve coincidencias ambiguas y añade reglas. Usa primero el asistente de configuración y después las secciones siguientes.",
},
connectedConfigWizard: {
eyebrow: "Configuración",
title: "Configurar la ingesta conectada",
lead: "Este asistente te guía para crear un origen, proteger su token, copiar la URL de ingesta y entender las reglas opcionales.",
pillWelcome: "Inicio",
pillSource: "Origen",
pillEndpoint: "URL de ingesta",
pillRule: "Reglas",
pillComplete: "Hecho",
welcomeTitle: "Qué estás configurando",
welcomeIntro: "Conectarás un sistema externo (SCADA, pasarela, script) para enviar eventos JSON mediante POST a este espacio de trabajo.",
welcomeStep1: "Crea un origen conectado (bandeja de entrada lógica).",
welcomeStep2: "Copia el token de ingesta de un solo uso desde la ventana emergente segura, el mismo flujo que las claves de API.",
welcomeStep3: "Copia la URL de POST y un payload de ejemplo para tu integración.",
welcomeStep4: "Opcionalmente, añade una regla: cuando los eventos coincidan con un patrón, ejecuta una acción clara (borrador, alerta o notificación).",
sourceTitle: "Crear un origen conectado",
sourceLead: "Dale al origen un nombre descriptivo que tu equipo reconozca. La clave interna debe ser única; déjala en blanco para generarla automáticamente.",
fieldSourceName: "Nombre visible",
placeholderSourceName: "p. ej. PLC de la planta norte",
fieldSourceKey: "Clave interna (opcional)",
hintSourceKey: "Solo letras, números y guiones. Se usa en registros y metadatos; no se muestra a los emisores.",
placeholderSourceKey: "p. ej. planta-norte-plc",
createSourceCta: "Crear origen y mostrar token",
creating: "Creando…",
defaultSourceName: "Origen conectado {{n}}",
endpointTitle: "Envía eventos a esta URL",
endpointLead: "Tu emisor debe usar POST HTTPS con JSON. Se prefiere el token de cada origen en la cabecera x-connected-source-token.",
postUrlLabel: "Tu URL de ingesta",
copyPostUrl: "Copiar línea POST",
copySampleJson: "Copiar JSON de ejemplo",
endpointNoSource: "Crea un origen en el paso anterior (o usa Nuevo origen arriba) para ver aquí tu URL de ingesta.",
endpointHeaderHint: "Cabecera obligatoria al usar el token de ingesta:",
endpointBearerHint: "Si usas en su lugar una cuenta de servicio del espacio de trabajo, envía Authorization: Bearer <clave de API> con ámbitos connected_*.",
openApiKeys: "Abrir Claves API y acceso",
ruleStepTitle: "Reglas (opcional)",
ruleStepLead: "Las reglas observan los eventos entrantes después de almacenarse. Cuando la clave de un evento coincide con tu patrón, AssetWRX ejecuta una acción, por ejemplo publicar en el buzón de salida de automatización para que las recetas puedan reaccionar.",
ruleStepHint: "Usa el generador de reglas de abajo para elegir el “cuándo” y el “entonces” en lenguaje sencillo. Las reglas nuevas empiezan pausadas para que puedas revisarlas antes de activarlas.",
completeTitle: "Ya estás listo para integrar",
completeBody: "Desplázate hacia abajo para gestionar orígenes, inspeccionar eventos recientes, resolver payloads sin coincidencia y ajustar reglas. Rota el token de ingesta cuando quieras; cada rotación muestra el nuevo secreto una vez en la misma ventana emergente.",
},
connectedIngestModal: {
title: "Token de ingesta (se muestra una vez)",
leadCreate: "Copia este token en un gestor de contraseñas o almacén de secretos. Envíalo como cabecera x-connected-source-token en cada POST a este origen.",
leadRotate: "Tu token de ingesta anterior dejó de funcionar al rotarlo. Copia el nuevo token y actualiza a todos los emisores antes de que se reanude el tráfico.",
copiedTitle: "Copiado",
copiedBody: "Valor copiado al portapapeles.",
missingTokenTitle: "No se devolvió ningún token",
missingTokenBody: "El servidor no devolvió un nuevo token de ingesta. Inténtalo de nuevo o revisa los registros de la Edge Function.",
},
connectedRules: {
builderTitle: "Crear una regla conectada",
builderSubtitle: "Las reglas responden a: “Cuando un evento se parece a esto, haz eso.” Los patrones usan claves de evento (por ejemplo telemetry.temperature o connected.*). Las acciones solo se ejecutan después de almacenar un evento; varias acciones requieren que el evento ya coincida con un activo.",
fieldRuleName: "Nombre de la regla (opcional)",
placeholderRuleName: "p. ej. Notificar cuando llegue telemetría",
whenLabel: "Cuando los eventos entrantes coincidan",
whenHint: "Elige con qué rigor coincidir con la clave del evento. La mayoría de los equipos empiezan con “Cualquier evento conectado” o un prefijo corto.",
matchAll: "Cualquier evento conectado",
matchPrefix: "Prefijo",
matchCustom: "Patrón avanzado",
placeholderPrefix: "p. ej. telemetry (se convierte en telemetry.*)",
customHint: "Usuarios avanzados: introduce un patrón completo como connected.* o job.status_changed.",
thenLabel: "Entonces haz esto",
actionTitle_outbox_publish: "Publicar en el buzón de salida de automatización",
actionBody_outbox_publish: "Emite un evento del espacio de trabajo que otros sistemas y recetas de automatización pueden consumir, similar a una difusión de webhook dentro de AssetWRX.",
actionTitle_asset_alert: "Generar una alerta de activo",
actionBody_asset_alert: "Escribe una entrada de actividad visible en el activo coincidente. Título personalizado opcional.",
actionTitle_asset_reposition: "Actualizar la ubicación del activo",
actionBody_asset_reposition: "Aplica una posición notificada por el dispositivo. Un activo móvil se mueve sin avisar; cualquier cosa que deba permanecer fija genera una reclamación para su responsable.",
actionTitle_inspection_create: "Crear borrador de inspección",
actionBody_inspection_create: "Abre un borrador de inspección en el activo coincidente. Requiere el UUID de una lista de control.",
actionTitle_job_create: "Crear borrador de orden de trabajo",
actionBody_job_create: "Abre un elemento de trabajo en borrador vinculado al activo coincidente cuando el resolutor encontró uno.",
fieldOutboxEventType: "Tipo de evento del buzón de salida",
fieldAlertTitle: "Título de la alerta (opcional)",
placeholderAlertTitle: "Si se deja vacío, usa el resumen del evento de forma predeterminada",
fieldChecklistTemplateId: "ID de la lista de control",
hintChecklistTemplateId: "UUID de una lista de control existente en este espacio de trabajo. El borrador de inspección usa esta lista de control.",
placeholderUuid: "00000000-0000-0000-0000-000000000000",
fieldJobTitle: "Título de la orden de trabajo (opcional)",
placeholderJobTitle: "Si se deja vacío, usa un título derivado del evento",
sourceScopeLabel: "Aplicar esta regla a",
sourceScopeHint: "Todos los orígenes, o solo eventos de un origen indicado abajo.",
sourceAll: "Todos los orígenes",
createRuleCta: "Crear regla (empieza pausada)",
ruleCreated: "Regla creada",
defaultRuleName: "Regla para {{pattern}}",
ruleDescriptionAuto: "Creada desde el generador de reglas de ingesta conectada.",
checklistRequiredTitle: "Se requiere una lista de control",
checklistRequiredBody: "Los borradores de inspección necesitan el UUID de una lista de control. Pega uno de las listas de control de tu espacio de trabajo o elige otra acción.",
},
connectedSections: {
reload: "Recargar",
newSource: "Nuevo origen",
rotateToken: "Rotar token",
sourcesTitle: "Orígenes",
sourcesSubtitle: "Cada origen tiene su propia URL de ingesta y ciclo de vida de token.",
sourcesEmpty: "Aún no hay orígenes conectados.",
sourceActivity: "Última recepción: {{received}} · Último evento: {{last}}",
never: "Nunca",
eventsTitle: "Eventos recientes",
eventsSubtitle: "Últimos payloads aceptados por la API (reprocesar es seguro si lo indica soporte).",
eventsEmpty: "Aún no hay eventos conectados.",
noSummary: "Aún no hay resumen del asistente.",
assetLabel: "Activo",
unresolved: "sin resolver",
reprocess: "Reprocesar",
reprocessed: "Evento reprocesado",
unresolvedTitle: "Cola sin resolver",
unresolvedSubtitle: "Eventos que no se pudieron asociar a un único activo; resuélvelos manualmente y reprocésalos si es necesario.",
unresolvedEmpty: "No hay eventos conectados sin resolver.",
resolveFirst: "Resolver primero",
candidates_one: "{{count}} activo candidato",
candidates_many: "{{count}} activos candidatos",
candidates_other: "{{count}} activos candidatos",
resolved: "Evento sin resolver resuelto",
noCandidateTitle: "No hay candidato disponible",
noCandidateBody: "Este evento sin resolver no tiene ningún activo candidato almacenado para aplicar automáticamente.",
rulesListTitle: "Reglas guardadas",
rulesListSubtitle: "Activa una regla cuando estés satisfecho con su patrón y acción. Las reglas pausadas nunca se ejecutan.",
rulesEmpty: "Aún no hay reglas conectadas.",
pause: "Pausar",
activate: "Activar",
noDescription: "No se proporcionó descripción.",
ruleActivated: "Regla activa",
rulePaused: "Regla pausada",
executionsTitle: "Historial de ejecuciones",
executionsSubtitle: "Últimas ejecuciones de reglas conectadas con estado de auditoría.",
executionsEmpty: "Aún no hay ejecuciones de reglas conectadas.",
attempt: "intento",
executionEvent: "Evento {{id}} · {{at}}",
alertActionTitle: "Fallo en la acción administrativa conectada",
alertActionBody: "Algo salió mal. Inténtalo de nuevo.",
healthTitle: "Estado de la integración",
healthSubtitle: "Estado operativo, postura de reintento y resultados de ingesta más recientes.",
healthLabel: "Salud",
lastSuccessLbl: "Última sincronización exitosa",
lastFailedLbl: "Última sincronización fallida",
logsLbl: "Registros / historial",
logsVal: "{{e}} eventos · {{r}} ejecuciones",
retryFailed: "Reintentar el último evento fallido",
copyPayload: "Copiar payload de prueba",
credsNote: "Credenciales: los tokens de origen se muestran una sola vez y después solo con su prefijo y sus últimos cuatro caracteres. Utilice claves de cuenta de servicio con ámbitos connected_* para integraciones con token Bearer.",
needsAction: "Acción necesaria",
needsReview: "Revisión necesaria",
healthyLbl: "Correcto",
notConfigured: "Sin configurar",
errPrefix: "Error: {{m}}",
seeSummary: "Ver resumen de resultados de ejecución.",
},
automationSubGuided: "Guiado",
automationSubRuns: "Historial de ejecuciones",
automationSubExpert: "Editor experto",
docsBarAutomationGuide: "Guía de automatización",
docsBarIntegrationsOverview: "Resumen de webhooks y conexiones",
docsBarBrowseApi: "Abrir la referencia de la API en directo",
docsBarApiHandbook: "Guía completa de conexión",
docsBarOpenApiKeys: "Claves API y cuentas de servicio",
docsBarConnectedPreview: "Vista previa conectada",
automationsKeysCalloutTitle: "Las cuentas de servicio y las claves API no se crean aquí",
automationsKeysCalloutBody: "Use la pestaña Claves API y acceso para crear cuentas de servicio, emitir claves API, verificar la puerta de enlace y copiar puntos finales. Esta pestaña es solo para recetas de automatización e historial de ejecuciones.",
automationsKeysCalloutCta: "Abrir Claves API y acceso",
apiExplorerLead: "Referencia de solo lectura de la API pública. «Pruébalo» está desactivado en este visor para que tus credenciales no se expongan a orígenes arbitrarios (CORS). Usa Claves API y acceso → Verificar conexión con tu sesión, o prueba con una clave de cuenta de servicio desde la misma pantalla.",
apiExplorerServerDescription: "API del espacio de trabajo de AssetWRX",
apiExplorerGoVerify: "Abrir Claves API y acceso para verificar la conexión",
apiExplorerBack: "Volver",
apiExplorerPhoneTitle: "Se explora mejor en una pantalla más grande",
apiExplorerPhoneBody: "La referencia interactiva de la API está pensada para tableta u ordenador. Ábrela ahí para explorar los endpoints y modelos. Puedes seguir gestionando las claves de API arriba y copiar tu URL base abajo.",
apiExplorerBaseUrlLabel: "URL base",
apiExplorerCovers: "Incluye activos y lugares, sitios, listas de verificación, inspecciones y su programación, órdenes de trabajo, planes y programas de mantenimiento, contactos, equipos, análisis, archivos, webhooks, automatización, dispositivos conectados, Power BI y agentes de IA. Sitios, listas de verificación, programación, mantenimiento y equipos son solo de lectura.",
apiExplorerSectionNeeds: "Interruptor del plan: {{names}}.",
apiExplorerSectionOff: "No incluido en su plan: {{names}} está desactivado para este espacio de trabajo.",
apiExplorerNotInPlan: "No incluido en su plan, por lo que estas llamadas se rechazan: {{sections}}.",
handbookTitleAutomation: "Guía de automatización (en la app)",
handbookTitleIntegrations: "Guía de API y conexiones (en la app)",
handbookLead: "Este contenido se incluye con la app a partir del Markdown canónico del repositorio del producto.",
handbookOpenHosted: "Abrir copia alojada",
handbookCopyMarkdown: "Copiar Markdown",
handbookCopyDoneTitle: "Copiado",
handbookCopyDoneBody: "El Markdown de la guía se copió al portapapeles.",
handbookCopyFailedTitle: "Error al copiar",
handbookCopyFailedBody: "No se pudo copiar al portapapeles en este dispositivo.",
handbookOpenFailedTitle: "No se pudo abrir el enlace",
handbookOpenFailedBody: "Revisa la URL de la documentación alojada en la configuración de entorno de tu espacio de trabajo.",
docsFallbackTitle: "Enlace de documentación",
docsFallbackAutomationIntro: "La documentación alojada aún no está configurada. Puedes copiar estas rutas de referencia internas para tus registros o para compartirlas con quien gestione las integraciones.",
docsFallbackApiIntro: "La documentación alojada aún no está configurada. Puedes copiar estas rutas de referencia internas para tus registros o para compartirlas con quien gestione las integraciones.",
docsFallbackCopy: "Copiar rutas de referencia",
docsFallbackClose: "Cerrar",
docsPathAutomation: "Guía de automatización (referencia interna)",
docsPathApi: "API e integraciones (referencia interna)",
docsPathOpenApiYaml: "Contrato OpenAPI (referencia interna)",
showAdvancedDetails: "Mostrar detalles avanzados",
hideAdvancedDetails: "Ocultar detalles avanzados",
loadingContracts: "Cargando contratos de integración…",
retryLoad: "Reintentar carga",
navSectionMain: "Módulos",
navSectionAutomation: "Vistas de disparadores",
guidedBadge: "Guiado",
recipeListTitle: "Recetas en este espacio de trabajo",
recipeListSubtitle: "Activa, pausa, duplica, archiva, ejecuta con JSON opcional, rota tokens entrantes y reintenta desde el historial.",
recipeNoActions: "sin acciones",
recipeListEmpty: "Aún no hay recetas.",
recipePause: "Pausar",
recipePaused: "Receta pausada",
recipeActivate: "Activar",
recipeActive: "Receta activa",
recipeManualRun: "Ejecución manual",
recipeDuplicate: "Duplicar",
recipeDuplicated: "Receta duplicada",
recipeRotateToken: "Rotar token",
recipeTokenRotated: "Token de webhook rotado",
recipeArchive: "Archivar",
recipeArchived: "Receta archivada",
guidedWizard: {
title: "Automatización guiada",
subtitle: "Elige una lista de control, rellena unos pocos campos y crea un borrador guardado en el servidor. La edición avanzada de recetas sigue en Disparadores de eventos → Editor experto.",
publicApiLead: "Todas las ejecuciones se realizan en tu espacio de trabajo sobre la API pública; nada se simula en la app.",
apisShortcutLabel: "Crear o ver cuentas de servicio y claves API",
apisShortcutA11y: "Abrir Claves API y acceso para administrar cuentas de servicio y claves API",
pillType: "Tipo",
pillBasics: "Datos básicos",
pillReview: "Revisión",
pillArtifacts: "Probar y guardar",
pillDone: "Hecho",
next: "Siguiente",
back: "Atrás",
categoryWorkflow: "Flujos de trabajo cotidianos",
categoryInspection: "Inspecciones",
categoryJob: "Órdenes de trabajo",
categoryAssetSync: "Sincronización de activos",
categoryInboundWebhook: "Webhooks entrantes",
categoryScheduled: "Programado",
categoryOutbound: "Pruebas y notificaciones",
fieldName: "Nombre",
placeholderName: "Nombre interno corto",
fieldDescription: "Descripción (opcional)",
placeholderDescription: "Quién usa esto y qué sistema lo recibe",
fieldForwardUrl: "Reenviar a URL HTTPS",
fieldDestinationUrl: "URL HTTPS de destino",
fieldSigningSecret: "Secreto de firma (opcional)",
placeholderSigningSecret: "Déjalo en blanco si tu receptor no verifica HMAC",
fieldFilterStatus: "Solo cuando el estado de la inspección sea igual a (opcional)",
placeholderFilterStatus: "p. ej. completed — déjalo en blanco para enviar en cada actualización",
fieldAssetEvent: "Evento del activo",
fieldIntervalMinutes: "Intervalo (minutos)",
fieldJobIdPath: "Campo del ID del trabajo en el cuerpo JSON",
fieldStatusPath: "Campo de estado en el cuerpo JSON",
reviewWhen: "Cuándo: ",
reviewDo: "Hacer: ",
reviewNeedFix: "Corrige los errores en Datos básicos para ver la receta compilada.",
artifactsLead: "Copia el YAML del contrato o el JSON de ejemplo para tus socios. Cuando estés listo, crea un borrador y después activa la receta y usa Ejecución manual con JSON desde la lista de abajo.",
copyYaml: "Copiar YAML del contrato",
manualRunHelp: "Ayuda de ejecución manual",
copySampleEvent: "Copiar JSON de evento de dominio de ejemplo",
copyManualInput: "Copiar entrada de ejemplo para ejecución manual",
saving: "Guardando…",
createDraftContinue: "Crear borrador y continuar",
draftCreatedAlert: "Borrador de automatización creado",
turnedOnAlert: "Automatización activada",
turnOn: "Activar",
saveDraft: "Guardar como borrador",
copiedTitle: "Copiado",
copiedYamlBody: "YAML del contrato copiado al portapapeles.",
copiedEventBody: "JSON de evento de ejemplo copiado.",
copiedManualBody: "Usa este cuerpo como entrada al llamar a ejecuciones manuales tras la activación.",
successTitle: "Borrador guardado",
successBody: "Tu receta aparece en la lista de abajo. Actívala cuando estés listo y usa Ejecución manual para probarla con JSON.",
successBodyActive: "Está activa. Cada ejecución aparece en el historial de esta automatización.",
createAnother: "Crear otra",
alertNeedTypeTitle: "Elige un tipo",
alertNeedTypeBody: "Selecciona una lista de control de automatización para continuar.",
alertInvalidTitle: "Revisa los campos",
alertInvalidBody: "Completa los campos obligatorios para continuar.",
manualHarnessTitle: "Banco de pruebas manual",
manualHarnessBodyGeneric: "Crea un borrador de “Webhook de prueba manual”, actívalo y después usa Ejecución manual en la fila de la receta con el JSON de ejemplo.",
manualHarnessCreateFirstTitle: "Crea primero",
manualHarnessCreateFirstBody: "Guarda esta automatización como borrador desde “Crear borrador y continuar”, después actívala y usa “Ejecución manual” en la fila de la receta con el JSON de ejemplo.",
},
manualRunModal: {
title: "Ejecución manual",
inputLabel: "Entrada JSON opcional (objeto)",
run: "Encolar ejecución",
cancel: "Cancelar",
errorInvalidJson: "Introduce un JSON válido o déjalo vacío para {}.",
errorNotObject: "La entrada debe ser un objeto JSON (no un array).",
successTitle: "Ejecución manual encolada",
successBody: "ID de ejecución: {{id}}\nEstado: {{status}}",
goToRuns: "Abrir historial de ejecuciones",
},
accessWizard: {
pageTitle: "Claves API y acceso",
pageSubtitle: "Resumen, verifica la pasarela, gestiona claves, crea una nueva clave, revisa las automatizaciones entrantes y después copia la URL base REST y las rutas. Nada aquí omite la seguridad de tu espacio de trabajo.",
pillPurpose: "Resumen",
pillVerify: "Verificar",
pillAccounts: "Claves existentes",
pillCreate: "Nueva clave",
pillInbound: "Entrante",
pillEndpoints: "Endpoints",
purposeTitle: "Qué puedes conectar",
purposeBody: "Las claves de API REST permiten que sistemas de confianza lean y escriban datos del espacio de trabajo. Los webhooks de salida de la plataforma se configuran por separado en la guía de conexión. Las URL entrantes de recetas son para desencadenadores de automatización.",
openHandbook: "Abrir la guía completa de conexión",
verifyTitle: "Verificar la API del espacio de trabajo (sesión)",
verifyLead: "Confirma que se puede acceder a la misma pasarela que usa la app para gestionar integraciones con tu sesión actual.",
verifyAppLoginVsApiKeyTitle: "Inicio de sesión en la app vs claves API",
verifyAppLoginVsApiKeyBody: "Inicia sesión en esta aplicación con tu cuenta de usuario (la misma sesión que en el resto de AssetWRX). Las claves API son solo para otros sistemas y scripts que llaman a la API REST del espacio de trabajo: no sustituyen iniciar sesión aquí.",
verifyConnection: "Verificar conexión",
verifying: "Verificando…",
sessionVerifyOk: "Accesible. Espacio de trabajo {{workspaceId}} · principal: {{principal}}",
accountsListTitle: "Cuentas de servicio existentes",
accountsListLead: "Las claves se almacenan con hash SHA-256; el texto sin cifrar solo se muestra una vez al crear o rotar. Actualiza la lista tras crear una clave en otro dispositivo.",
accountsListSecretCalloutTitle: "Por qué no ves la clave completa en esta lista",
accountsListSecretCalloutBody: "Solo se guarda un hash en el servidor. El secreto completo aparece una vez en el cuadro al crear o rotar: cópialo entonces a un gestor de contraseñas. Abajo solo verás nombres de cuenta y ámbitos. Si cerraste el cuadro sin guardar, usa «Rotar clave» para emitir un secreto nuevo.",
accountsAdminErrorHint: "Solo los administradores del espacio de trabajo pueden listar o crear cuentas de servicio y claves API. Inicia sesión con una cuenta de administrador o pide a un propietario que te conceda admin.",
refreshList: "Actualizar lista",
refreshLoading: "Cargando…",
lastUsed: "Último uso {{when}}",
neverUsed: "Aún no se ha usado",
rotatedOn: "Clave rotada {{when}}",
revokedOn: "Revocada {{when}}",
rotateKey: "Rotar clave",
revoke: "Revocar",
revoked: "Revocada",
noAccounts: "Aún no hay cuentas de servicio.",
createTitle: "Crear cuenta de servicio",
createLead: "Elige un nombre, una descripción opcional, ámbitos y una caducidad de clave opcional. Verás la clave completa una vez — guárdala en un almacén seguro.",
endpointsTitle: "Pasarela REST y rutas",
endpointsLead: "Todas las llamadas REST versionadas pasan por esta URL base. Añade las rutas del contrato (por ejemplo /v1/assets). Las URL entrantes de automatización son independientes y se muestran en el paso Entrante.",
endpointsBaseLabel: "URL base de la pasarela",
endpointsCopyBase: "Copiar URL base",
endpointsCopiedTitle: "Copiado",
endpointsCopiedBody: "URL base de la pasarela copiada al portapapeles.",
endpointsExamplesTitle: "Ejemplos (relativos a la base)",
endpointsExampleStatus: "GET /v1/status — estado de la API del espacio de trabajo (requiere status:read para claves de API)",
endpointsExampleAssets: "GET /v1/assets — lista de activos (requiere assets:read)",
endpointsExampleInbound: "Las automatizaciones entrantes usan URL HTTPS específicas de cada receta del paso Entrante, no esta URL base.",
endpointsExampleDocs: "Cada ruta, parámetro de consulta y forma del cuerpo está en la referencia OpenAPI en directo.",
endpointsAuthHint: "Desde otros sistemas: envía la cabecera apikey: <tu clave publicable de AssetWRX> y Authorization: Bearer <tu clave de API de cuenta de servicio>. Esta app usa en su lugar tu sesión de inicio de sesión.",
endpointsOpenReference: "Abrir la referencia de la API en directo",
fieldName: "Nombre",
fieldDescription: "Descripción (opcional)",
fieldExpiry: "La primera clave caduca el (fecha ISO opcional)",
placeholderName: "Sincronización nocturna del ERP",
placeholderDescription: "Nota interna",
saving: "Guardando…",
createShowKey: "Crear y mostrar clave",
inboundTitle: "Endpoints entrantes de recetas",
inboundLead: "Se muestra para recetas que usan el desencadenador de webhook entrante. Las URL y los secretos aparecen en la receta tras la activación.",
inboundToken: "Token {{prefix}}…{{last}}",
inboundEmpty: "Crea una receta con el desencadenador de webhook entrante para generar un endpoint con token.",
keyVerifyOk: "La solicitud de prueba con esta clave se ha realizado correctamente (GET /v1/status).",
keyVerifyFail: "No se pudo verificar la clave con GET /v1/status: {{message}}",
keyVerifySkipped: "Añade el ámbito “Estado del espacio de trabajo” (status:read) para verificar las claves nuevas automáticamente la próxima vez.",
keyRevealModalTitle: "Su nueva clave API",
keyRevealModalLead: "Copie este secreto y guárdelo en un gestor de contraseñas. No podrá ver la clave completa otra vez en esta lista.",
keyRevealCopy: "Copiar clave",
keyRevealSaved: "Ya la guardé",
keyRevealMissingFromServer: "El servidor no devolvió una clave. Inténtelo de nuevo o revise los registros de la función Edge.",
keyRevealCopiedTitle: "Copiado",
keyRevealCopiedBody: "Clave API copiada al portapapeles.",
},
mcpWizard: {
pageTitle: "Servidores MCP del espacio de trabajo",
pageSubtitle: "Conecta servidores MCP remotos aprobados mediante HTTPS, almacena los secretos cifrados, ejecuta el descubrimiento desde el backend y después elige qué herramientas y recursos puede proponer el asistente.",
flowLabel: "Configuración guiada",
pillIntro: "Resumen",
pillServer: "Servidor",
pillCredentials: "Secretos",
pillVerify: "Probar y descubrir",
pillCatalog: "Lista de permitidos",
pillHistory: "Historial",
loading: "Cargando configuración de MCP…",
loadError: "No se pudo cargar la configuración de MCP.",
detailLoadError: "No se pudieron cargar las herramientas y recursos de este servidor.",
introTitle: "Qué estás configurando",
introLead: "El Model Context Protocol (MCP) permite que el asistente operativo llame a herramientas externas y lea recursos externos después de que confirmes cada propuesta. Este espacio de trabajo mantiene una lista de permitidos estricta.",
introWhatTitle: "Restricciones de la versión 1",
introWhatBody: "Solo se admiten endpoints remotos HTTP JSON-RPC. Las credenciales se cifran en el servidor; la app nunca recibe secretos en texto sin cifrar después de guardarlos. El descubrimiento y las llamadas siempre se ejecutan a través de la Edge Function de la API pública.",
introStepsTitle: "Sigue estos pasos en orden",
introStep1: "Registra el nombre del servidor y la URL base HTTPS documentada por tu proveedor.",
introStep2: "Guarda las credenciales si el endpoint requiere un token Bearer, una cabecera de clave de API o una cabecera personalizada.",
introStep3: "Prueba la conexión y después ejecuta el descubrimiento para que las herramientas y recursos aparezcan en el catálogo.",
introStep4: "Activa solo las herramientas y recursos que este espacio de trabajo deba invocar.",
introStep5: "Opcionalmente, habilita “Asistente” por fila para que el planificador pueda proponer esa herramienta o recurso (sigues confirmando antes de que se ejecute).",
introStep6: "Revisa el historial de invocaciones para auditorías y solución de problemas.",
serverListTitle: "Elige o añade un servidor",
serverListLead: "Selecciona una tarjeta para editarla, o usa “Añadir servidor MCP” para una fila nueva, y después guarda abajo.",
serverCardCounts: "Herramientas: {{tools}} · Recursos: {{resources}}",
addServer: "Añadir servidor MCP",
serverFormTitle: "Detalles del servidor",
serverFormLead: "Pega la URL exacta del endpoint MCP de tu proveedor. Debe usar HTTPS; usa el formato de ejemplo de abajo si no estás seguro.",
fieldName: "Nombre",
fieldDescription: "Descripción (opcional)",
fieldBaseUrl: "URL base (HTTPS)",
fieldBaseUrlPlaceholder: "https://mcp.example.com/v1",
fieldBaseUrlHint: "Debe empezar por https://. Usa la ruta completa que documenta tu host MCP (normalmente /mcp, /sse o /v1). No se admiten HTTP ni nombres de host sin ruta.",
alertBaseUrlHttpsTitle: "Se requiere una URL HTTPS",
alertBaseUrlHttpsBody: "La URL base de MCP debe empezar por https://. Ejemplo: https://mcp.example.com/v1",
invalidBaseUrlFormat: "Introduce una URL completa incluyendo https://, por ejemplo https://mcp.example.com/v1",
fieldTimeoutMs: "Tiempo de espera (ms)",
fieldMaxPayload: "Bytes máximos del payload",
fieldHeaderName: "Nombre de la cabecera",
fieldSecret: "Secreto",
secretPlaceholderNew: "Introduce el secreto una vez para cifrarlo",
secretPlaceholderRotate: "Introduce un nuevo secreto para rotar el valor almacenado",
saving: "Guardando…",
updateServer: "Actualizar servidor",
createServer: "Crear servidor",
serverSavedTitle: "Servidor MCP guardado",
serverSavedBody: "{{name}} se ha guardado. Continúa a Secretos cuando el endpoint necesite autenticación.",
serverSaveFailedTitle: "Error al guardar",
serverSaveFailed: "No se pudo guardar el servidor MCP.",
credentialsTitle: "Credenciales cifradas",
credentialsLead: "Elige cómo se autentica el backend ante el servidor MCP. Usa “ninguna” solo para hosts que no requieran un secreto.",
credentialsNeedServer: "Guarda un servidor en el paso anterior antes de añadir credenciales.",
credentialStored: "Almacenado: {{type}} {{prefix}}…{{last}}",
saveCredentials: "Guardar credenciales",
credentialsSavedTitle: "Credenciales actualizadas",
credentialsSavedBody: "Los secretos se cifran en reposo. Después, solo se devuelven metadatos enmascarados a la app.",
credentialsSaveFailedTitle: "Error al actualizar las credenciales",
credentialsSaveFailed: "No se pudieron guardar las credenciales.",
noSecretStored: "No hay ningún secreto almacenado",
verifyTitle: "Probar conexión y descubrir",
verifyLead: "La prueba realiza un intercambio ligero de inicialización. El descubrimiento lista las herramientas y recursos para que puedas aprobarlos.",
verifyOrderTitle: "Orden recomendado",
verifyOrderBody: "Ejecuta primero Probar conexión. Si tiene éxito, ejecuta Descubrir metadatos y después pasa a Lista de permitidos para habilitar entradas.",
verifyNeedServer: "Guarda primero un servidor y después vuelve aquí.",
testConnection: "Probar conexión",
discoverMetadata: "Descubrir metadatos",
testOkTitle: "Prueba de conexión correcta",
testOkBody: "Completado en {{ms}} ms.",
discoverOkTitle: "Descubrimiento completado",
discoverOkBody: "Se encontraron {{tools}} herramientas y {{resources}} recursos.",
testFailedTitle: "Error en la prueba de conexión",
discoverFailedTitle: "Error en el descubrimiento",
actionFailedGeneric: "No se pudo completar esa operación.",
catalogTitle: "Lista de permitidos para herramientas y recursos",
catalogLead: "El espacio de trabajo habilita o deshabilita si el backend puede llamar a una entrada. Los interruptores de asistente añaden visibilidad para el planificador además de eso.",
catalogNeedServer: "Guarda un servidor y ejecuta el descubrimiento antes de gestionar el catálogo.",
toolsHeading: "Herramientas",
resourcesHeading: "Recursos",
noTools: "Aún no se han descubierto herramientas. Ejecuta Descubrir metadatos en el paso anterior.",
noResources: "Aún no se han descubierto recursos. Ejecuta Descubrir metadatos en el paso anterior.",
workspaceOn: "Espacio de trabajo activado",
workspaceOff: "Espacio de trabajo desactivado",
assistantOn: "Asistente activado",
assistantOff: "Asistente desactivado",
historyTitle: "Historial de invocaciones",
historyLead: "Cada llamada registra el destino, el tiempo, el estado y vistas previas depuradas del payload.",
noInvocations: "Aún no se han registrado invocaciones de MCP.",
invocationMeta: "Duración {{ms}} ms · {{when}}",
maskedLine: "Máscara de la última credencial: {{mask}}",
alertNeedServerTitle: "Guarda primero un servidor",
alertNeedServerBody: "Crea o selecciona un servidor, completa los campos obligatorios y pulsa Crear servidor o Actualizar servidor antes de continuar.",
alertServerFieldsTitle: "Revisa los campos obligatorios",
alertServerFieldsBody: "Introduce un nombre visible y una URL base HTTPS antes de continuar.",
alertNoServerTitle: "No hay ningún servidor seleccionado",
alertNoServerBody: "Selecciona o crea un servidor antes de guardar credenciales.",
toolUpdateFailedTitle: "Error al actualizar la herramienta",
toolUpdateFailed: "No se pudo actualizar la herramienta MCP.",
resourceUpdateFailedTitle: "Error al actualizar el recurso",
resourceUpdateFailed: "No se pudo actualizar el recurso MCP.",
},
editor: {
  saved: "Automatización actualizada",
  saveFailed: "No se pudo guardar",
  title: "Editar automatización",
  notGuidedTitle: "No es una automatización guiada",
  notGuidedDesc: "Esta se creó en el editor avanzado. Edítala allí.",
  save: "Guardar",
},
guidedForm: {
  severityLabel: "Cuando encuentre",
  severityAny: "Cualquier problema",
  severityUrgent: "Solo problemas urgentes",
  checklistLabel: "Solo para esta lista de comprobación",
  anyChecklist: "Cualquier lista de comprobación",
  assignLabel: "Asignar la orden de trabajo a",
  nobodyYet: "Nadie todavía",
  urgencyLabel: "Urgencia de la orden de trabajo de renovación",
  urgencyDefault: "Normal",
  urgencyHigh: "Alta",
  urgencyUrgent: "Urgente",
  thresholdLabel: "Órdenes de trabajo por este importe o más ({{currency}})",
  approverLabel: "Quién las aprueba",
  choosePerson: "Elegir una persona",
  daysLabel: "Sin respuesta durante",
  daysOption_one: "{{count}} día",
  daysOption_other: "{{count}} días",
  assetCreated: "Creado",
  assetUpdated: "Actualizado",
  assetDeleted: "Eliminado",
  titlePathLabel: "El título de la orden de trabajo viene de este campo del JSON",
  unknownChoice: "Ya no está en el espacio de trabajo",
  wholeTeam: "Todo el equipo",
  notifyLabel: "Avisar a",
  nobody: "Nadie",
  choosePersonOrTeam: "Elegir una persona o un equipo",
  close: "Cerrar",
  search: "Buscar…",
  noMatch: "No hay coincidencias.",
  daysOption_many: "{{count}} días",
},
},
connectedAssets: {
title: "Activos conectados",
lead: "Los conectores IoT y la telemetría en vivo aparecerán aquí. Área reservada para funciones futuras.",
backToIntegrations: "Volver a automatizaciones",
moreTitle: "Alcance y hoja de ruta",
moreSummary: "Conectores, estado de dispositivos e integraciones de automatización.",
moreBody: "Los activos conectados mostrarán lecturas en vivo, última actividad y enlaces a inspecciones y trabajos cuando el espacio de trabajo active integraciones. Use automatizaciones para aprovisionar conectores y gestionar el acceso a datos.",
showMore: "Mostrar más",
showLess: "Mostrar menos",
},
apiAccess: {
catalogScopesLabel: "Áreas de acceso a la API",
noScopes: "No hay áreas de acceso seleccionadas",
fullAccessChip: "Acceso completo a la API",
scopesSectionTitle: "Qué puede usar esta clave",
scopesSectionHint: "Elige un kit inicial para herramientas comunes y después ajusta con las casillas. Activa solo lo que necesite tu integración.",
presetsLabel: "Kits iniciales",
preset_starter_title: "Informes y listados",
preset_starter_subtitle: "Lee el estado del espacio de trabajo, activos, inspecciones y trabajos; ideal para paneles y sincronización de solo lectura.",
preset_field_title: "Operaciones de campo",
preset_field_subtitle: "Añade la creación y actualización de activos, contactos, inspecciones y trabajos; habitual en herramientas móviles o de equipos.",
preset_automation_title: "Automatizaciones y eventos",
preset_automation_subtitle: "Incluye recetas, catálogo de automatización y lectura de eventos; para flujos de trabajo de estilo Zapier y webhooks.",
preset_full_title: "Todo (administrador)",
preset_full_subtitle: "Todo el poder de la API, incluidos GraphQL y la gestión de otras claves. Usa esto solo para software de servidor de confianza.",
preset_read_only_title: "Solo lectura",
preset_read_only_subtitle: "Consulta el estado del espacio de trabajo, activos, contactos, inspecciones, trabajos y el feed de eventos. No se puede cambiar nada.",
preset_power_bi_title: "Power BI",
preset_power_bi_subtitle: "Lee activos, inspecciones y trabajos mediante la fuente OData. No se puede cambiar nada.",
preset_power_automate_title: "Power Automate",
preset_power_automate_subtitle: "Lo que necesita el conector de Power Automate: leer activos; leer y crear trabajos e inspecciones; iniciar flujos desde eventos.",
preset_asset_operations_title: "Operaciones de activos",
preset_asset_operations_subtitle: "Crea y actualiza activos y contactos, con acceso de lectura a listas de control; para mantener sincronizado un registro de activos.",
preset_inspections_title: "Inspecciones",
preset_inspections_subtitle: "Crea y actualiza inspecciones, con acceso de lectura a activos, trabajos y listas de control; para herramientas de inspección.",
preset_wrx_operations_title: "Operaciones WRX",
preset_wrx_operations_subtitle: "Lectura y escritura completas en activos, contactos, inspecciones y órdenes de trabajo (WRX), además del feed de eventos; para sistemas de operaciones.",
preset_full_integration_title: "Integración completa",
preset_full_integration_subtitle: "Acceso completo a la API, incluidos GraphQL y la gestión de claves. Usa esto solo para software de servidor de confianza.",
preset_custom_access_title: "Personalizado",
preset_custom_access_subtitle: "Elige exactamente qué áreas de acceso necesita esta conexión.",
preset_ai_read_title: "Leer información de activos",
preset_ai_read_subtitle: "Permite que el agente de IA lea activos, contactos, inspecciones y trabajos. No puede hacer cambios.",
preset_ai_inspection_title: "Asistente de inspección",
preset_ai_inspection_subtitle: "Permite que el agente de IA lea activos y listas de control, y cree o actualice inspecciones.",
preset_ai_wrx_title: "Asistente WRX",
preset_ai_wrx_subtitle: "Permite que el agente de IA lea y actualice activos, contactos, inspecciones y trabajos (WRX).",
preset_ai_operations_title: "Asistente de operaciones",
preset_ai_operations_subtitle: "Acceso operativo completo para el agente de IA, incluido el contexto de automatización y eventos conectados.",
preset_custom_ai_title: "Personalizado",
preset_custom_ai_subtitle: "Elige exactamente qué herramientas e información puede usar esta conexión de IA.",
group_overview: "Resumen y asistente",
group_records: "Activos, contactos, inspecciones y trabajos",
group_events: "Webhooks y eventos",
group_automation: "Generador de automatización",
group_connected: "Fuentes, eventos y reglas conectados",
group_advanced: "Avanzado y gestión de claves",
scope_status_read: "Estado del espacio de trabajo",
scope_dashboard_read: "Datos del panel",
scope_dashboards_read: "Paneles guardados",
scope_assistant_context_read: "Contexto del asistente (lectura)",
scope_assets_read: "Ver activos",
scope_assets_write: "Crear y editar activos",
scope_contacts_read: "Ver contactos",
scope_contacts_write: "Crear y editar contactos",
scope_inspections_read: "Ver inspecciones",
scope_inspections_write: "Crear y editar inspecciones",
scope_jobs_read: "Ver trabajos",
scope_jobs_write: "Crear y editar trabajos",
scope_templates_read: "Ver listas de control",
scope_templates_write: "Crear y editar listas de control",
scope_mcp_read: "Ver la configuración de IA (MCP)",
scope_mcp_write: "Gestionar la configuración de IA (MCP)",
scope_mcp_invoke: "Usar herramientas de IA (MCP)",
scope_connected_sources_read: "Ver fuentes conectadas",
scope_connected_sources_write: "Gestionar fuentes conectadas",
scope_connected_events_read: "Ver eventos conectados",
scope_connected_events_write: "Enviar eventos conectados",
scope_connected_rules_read: "Ver reglas conectadas",
scope_connected_rules_write: "Gestionar reglas conectadas",
scope_webhooks_read: "Ver webhooks de salida",
scope_webhooks_write: "Gestionar webhooks de salida",
scope_events_read: "Leer el feed de eventos",
scope_graphql_read: "GraphQL (lectura)",
scope_graphql_write: "GraphQL (escritura)",
scope_service_accounts_read: "Ver claves de API y cuentas de servicio",
scope_service_accounts_write: "Gestionar claves de API y cuentas de servicio",
scope_automation_catalog_read: "Ver catálogo de automatización",
scope_automation_recipes_read: "Ver recetas",
scope_automation_recipes_write: "Crear y editar recetas",
scope_automation_runs_read: "Ver ejecuciones de recetas",
scope_automation_actions_write: "Ejecutar acciones de automatización",
alertNameTitle: "Se requiere un nombre",
alertNameBody: "Introduce un nombre corto para que tu equipo sepa para qué sirve esta integración.",
alertScopesTitle: "Elige al menos un área",
alertScopesBody: "Elige un kit inicial o marca una o más áreas de acceso.",
alertExpiryTitle: "Revisa la fecha de caducidad",
alertExpiryBody: "Usa una fecha y hora válidas, o deja la caducidad en blanco.",
alertStoreKeyTitle: "Copia tu clave de API ahora",
alertStoreKeyBody: "Esta es la única vez que se muestra la clave completa. Guárdala en un gestor de contraseñas o almacén seguro.\n\n{{key}}",
},
defaults: {
  memberNotice: "Solo un administrador puede cambiar el idioma y la zona horaria del espacio de trabajo. Los tuyos están en Preferencias.",
  saveFailedBody: "Ese cambio no se guardó. Comprueba tu conexión e inténtalo de nuevo.",
  saveFailedTitle: "No se guardó",
  currencyHint: "Se usa para los costes que añades. Es tuya, no del espacio de trabajo; un equipo puede fijar la suya.",
regionalSummary: "Valores regionales predeterminados",
regionalBody: "Los valores del espacio de trabajo se aplican cuando un miembro deja el idioma o la zona vacíos en su perfil. La configuración personal siempre tiene prioridad.",
workspaceDefaultLanguage: "Idioma predeterminado del espacio de trabajo",
workspaceDefaultTimezone: "Zona horaria predeterminada del espacio de trabajo",
effectiveLanguage: "Su idioma efectivo",
effectiveTimezone: "Su zona horaria efectiva",
notSet: "Sin definir",
openOrganization: "Editar en perfil de organización",
loading: "Cargando…",
orgHint: "Los valores predeterminados se editan en el perfil de organización. Usan las mismas listas admitidas que el idioma y la zona personales.",
categorySubtitle: "Valores predeterminados para su espacio de trabajo. Se usan para inspecciones y órdenes de trabajo; los equipos pueden anularlos.",
shareMethodEmail: "Correo electrónico",
languageOptionA11y: "Idioma del espacio de trabajo {{label}}",
timezoneOptionA11y: "Zona horaria predeterminada del espacio de trabajo",
currencyLabel: "Tu moneda",
currencyOptionA11y: "Moneda {{code}}",
shareMethodLabel: "Comunicación (método para compartir)",
shareMethodOptionA11y: "Método para compartir predeterminado {{label}}",
teamOverridesA11y: "Abrir la configuración del equipo y sus anulaciones",
teamOverridesLink: "Configuración del equipo y anulaciones",
searchTimezone: "Buscar zona horaria",
},
organization: {
defaultLanguageLabel: "Idioma predeterminado",
timezoneLabel: "Zona horaria predeterminada",
notSet: "Sin definir",
languageHelper: "Se usa cuando el idioma personal no está definido: luego el del dispositivo si está admitido, luego inglés (EE. UU.).",
timezoneHelper: "Se usa cuando la zona personal no está definida: luego la del dispositivo, luego UTC.",
},
assetTypes: {
headerSubtitle: "Tus propios tipos de activo y lugar, y los detalles que pide cada uno",
intro: "Añade los tipos de activo que gestiona tu espacio de trabajo, como una enfriadora, una habitación de hotel o un ascensor, y los detalles que se rellenan para cada uno. Cada activo de ese tipo pide los mismos detalles.",
add: "Añadir tipo de activo",
addTitle: "Nuevo tipo de activo",
editTitle: "Editar tipo de activo",
nameLabel: "Nombre",
namePlaceholder: "Por ejemplo Enfriadora o Habitación",
nameRequired: "Ponle un nombre al tipo",
kindLabel: "Es un",
kindLocked_one: "Lo usa {{count}} activo, así que su clase no cambia.",
kindLocked_many: "Lo usan {{count}} activos, así que su clase no cambia.",
kindLocked_other: "Lo usan {{count}} activos, así que su clase no cambia.",
descriptionLabel: "Descripción",
descriptionPlaceholder: "Opcional. Qué abarca este tipo",
fieldsLabel: "Detalles que rellenar",
fieldsHint: "Cada activo de este tipo los muestra en su página de detalle y en el formulario de creación.",
fieldLabel: "Nombre del detalle",
fieldPlaceholder: "Por ejemplo Refrigerante o Número de camas",
fieldKinds: {
text: "Texto",
number: "Número",
date: "Fecha",
choice: "Elegir de una lista",
yes_no: "Sí o no",
},
optionsLabel: "Opciones",
optionsPlaceholder: "Separadas por comas, por ejemplo R410A, R32, R134a",
optionsRequired: "Añade al menos una opción",
unitLabel: "Unidad",
unitPlaceholder: "Opcional, por ejemplo kW",
requiredLabel: "Obligatorio",
removeField: "Quitar detalle",
addField: "Añadir detalle",
cancel: "Cancelar",
save: "Guardar",
saved: "Tipo de activo guardado",
saveFailedTitle: "No se pudo guardar el tipo de activo",
saveFailedBody: "Comprueba tu conexión y vuelve a intentarlo.",
fieldCount_one: "{{count}} detalle",
fieldCount_many: "{{count}} detalles",
fieldCount_other: "{{count}} detalles",
usedBy_one: "lo usa {{count}} activo",
usedBy_many: "lo usan {{count}} activos",
usedBy_other: "lo usan {{count}} activos",
archived: "Archivado",
edit: "Editar",
archive: "Archivar",
restore: "Restaurar",
showArchived_one: "Mostrar {{count}} tipo archivado",
showArchived_many: "Mostrar {{count}} tipos archivados",
showArchived_other: "Mostrar {{count}} tipos archivados",
hideArchived: "Ocultar tipos archivados",
emptyTitle: "Aún no tienes tipos de activo propios",
emptyBodyAdmin: "Añade uno para dar a un tipo de activo sus propios detalles.",
emptyBody: "Un propietario o administrador puede añadir tipos de activo al espacio de trabajo.",
archiveConfirmTitle: "¿Archivar este tipo de activo?",
archiveConfirmBody: "Los activos que lo usan lo conservan junto con sus detalles. Deja de aparecer al añadir activos nuevos. Puedes restaurarlo en cualquier momento.",
},
industryPacks: {
  later: "Más tarde",
  onboardingFailedBody: "No llegaron todas las listas predefinidas de su sector. Toque Intentar de nuevo para abrir los paquetes por sector y añadirlas.",
  onboardingFailedTitle: "Algunas listas no se añadieron",
  openTemplates: "Abrir listas de control",
  perAssetNote: "Instalar el paquete añade las listas. Los planes de mantenimiento y lo que hay que acreditar se sugieren en cada activo afín, para aceptarlos allí.",
title: "Paquetes por sector",
headerSubtitle: "Tipos de activo, listas de comprobación y planes iniciales para su sector",
subtitle: "Un punto de partida preparado para lo que gestiona. Añada lo útil, cambie lo que quiera y quite el resto.",
disclaimer: "Sugerencias para empezar, no asesoramiento legal. Compruebe qué se aplica donde opera.",
installed: "Instalado",
notInstalled: "No instalado",
installedCount_one: "{{installed}} de {{count}} lista",
installedCount_many: "{{installed}} de {{count}} listas",
installedCount_other: "{{installed}} de {{count}} listas",
newAvailable_one: "{{count}} lista nueva disponible",
newAvailable_other: "{{count}} listas nuevas disponibles",
install: "Instalar paquete",
installing: "Instalando…",
addRecommended: "Añadir listas recomendadas",
upToDate: "Ya tiene todo lo de este paquete.",
remove: "Quitar paquete",
removeConfirmTitle: "¿Quitar este paquete?",
removeConfirmBody: "Las listas que haya editado se quedan. Solo se quitan las listas del paquete sin cambios, y el activo de ejemplo se va con el último paquete.",
removeConfirmAction: "Quitar",
removedToast_one: "{{count}} lista quitada.",
removedToast_other: "{{count}} listas quitadas.",
removedSampleNote: "También se quitó el activo de ejemplo.",
keptNote_one: "Se conserva {{count}} lista porque la editó.",
keptNote_other: "Se conservan {{count}} listas porque las editó.",
installedToast: "Listas añadidas. Las encontrará en Listas de control.",
partialToast: "No se pudieron añadir algunos elementos. Inténtelo de nuevo.",
retry: "Reintentar",
sections: {
assetTypes: "Qué puede añadir",
templates: "Listas de control",
maintenance: "Mantenimiento",
compliance: "Qué acreditar",
},
suggestions: {
title: "De su paquete por sector",
body: "Sugerencias para este tipo de activo. No se añade nada hasta que lo elija.",
addPlan: "Añadir plan",
planAdded: "Añadido",
declare: "Hacer seguimiento",
declared: "En seguimiento",
empty: "No queda nada que sugerir para este activo.",
},
packs: {
property: {
name: "Inmuebles",
description: "Viviendas, pisos y locales — estado, entrada y salida, seguridad contra incendios y los certificados correspondientes.",
},
fleet: {
name: "Flota",
description: "Coches, furgonetas, camiones y remolques — revisiones diarias, daños, entrega y mantenimiento por fecha o kilometraje.",
},
equipment: {
name: "Equipos",
description: "Máquinas, herramientas y maquinaria — revisiones previas al uso, estado, mantenimiento por horas y evidencias de calibración.",
},
facilities: {
name: "Instalaciones",
description: "Edificios y sus instalaciones — mantenimiento programado, inspecciones de seguridad, salas de máquinas y evidencias obligatorias.",
},
},
newAvailable_many: "{{count}} listas nuevas disponibles",
removedToast_many: "{{count}} listas quitadas.",
keptNote_many: "Se conservan {{count}} listas porque las editó.",
},
automationDescribe: {
chosenPerson: "la persona elegida",
chosenTeam: "los miembros del equipo elegido",
chosenChecklist: "la lista de comprobación elegida",
chosenApprover: "el aprobador elegido",
personAndTeam: "{{user}} y {{team}}",
theThreshold: "el umbral",
yourUrl: "su URL",
severityUrgent: "un problema urgente",
severityAny: "cualquier problema",
templateClause: " con «{{name}}»",
assignedClause: " asignada a {{name}}",
notifyClause: " y avisará a {{who}}",
statusClause: " a «{{status}}»",
failedFollowUp: "Cuando una inspección detecte {{severity}}{{template}}, AssetWRX creará una orden de trabajo de seguimiento{{assigned}}{{notify}}.",
renewalWork: "Cuando un certificado o documento llegue a su fecha de recordatorio, AssetWRX creará una orden de trabajo de renovación en el activo{{notify}}.",
highCostApproval: "Cuando se cree una orden de trabajo cuyo importe alcance {{amount}} o más, AssetWRX pedirá que {{approver}} la apruebe.",
unansweredChase_one: "Cuando un contratista no haya respondido a una invitación o solicitud de presupuesto en {{count}} día, AssetWRX avisará a {{who}}, y de nuevo cada semana hasta que se responda.",
unansweredChase_many: "Cuando un contratista no haya respondido a una invitación o solicitud de presupuesto en {{count}} de días, AssetWRX avisará a {{who}}, y de nuevo cada semana hasta que se responda.",
unansweredChase_other: "Cuando un contratista no haya respondido a una invitación o solicitud de presupuesto en {{count}} días, AssetWRX avisará a {{who}}, y de nuevo cada semana hasta que se responda.",
inspectionCompleted: "Cuando se complete una inspección, AssetWRX enviará sus datos a {{host}}.",
inspectionUpdated: "Cuando se actualice una inspección{{status}}, AssetWRX enviará sus datos a {{host}}.",
jobCompleted: "Cuando se complete una orden de trabajo, AssetWRX enviará sus datos a {{host}}.",
jobStatusChanged: "Cuando una orden de trabajo cambie de estado, AssetWRX enviará sus datos a {{host}}.",
assetCreated: "Cuando se cree un activo, AssetWRX enviará sus datos a {{host}}.",
assetDeleted: "Cuando se elimine un activo, AssetWRX enviará sus datos a {{host}}.",
assetUpdated: "Cuando se actualice un activo, AssetWRX enviará sus datos a {{host}}.",
webhookTick_one: "Cada {{count}} minuto, AssetWRX llamará a {{host}}.",
webhookTick_many: "Cada {{count}} de minutos, AssetWRX llamará a {{host}}.",
webhookTick_other: "Cada {{count}} minutos, AssetWRX llamará a {{host}}.",
inboundForward: "Cuando el webhook entrante de esta automatización reciba JSON, AssetWRX lo reenviará a {{host}}.",
inboundJobStatus: "Cuando el webhook entrante de esta automatización reciba JSON, AssetWRX actualizará con él el estado de la orden de trabajo indicada.",
inboundCreateJob: "Cuando el webhook entrante de esta automatización reciba JSON, AssetWRX creará con él una orden de trabajo.",
manualTest: "Cuando la ejecute manualmente, AssetWRX enviará un mensaje de prueba a {{host}}.",
fallback: "Automatización",
},
};
